<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <!-- Alert message -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <loading v-model:active="isLoading"
      :can-cancel="true" 
      :is-full-page="fullPage" :color="primary_code" />
    <!-- main content -->
    <!-- Header Component -->
    <div>
      <HeaderComponent :headerTitle="headerText" v-if="itemData == ''" :router-link="{ name: 'ReturnClaimRequestRia' }"
        :router-link-text="'Return / Claim Requests'" :return-condition="true" :component-name="componentText" />
        <HeaderComponent :headerTitle="headerText" v-else-if="itemData !== ''" :router-link="{ name: 'ReturnCreationRia' }"
        :router-link-text="'Return / Claim Requests'" :return-condition="true" :component-name="componentText" />
    </div>

    <!-- add image popup -->
    <v-row justify="center">
      <v-dialog v-model="addImagesPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 mt-0">
            <v-card-title>
              <v-row class="ma-1">
              <span>Select images</span>
              <v-spacer></v-spacer>
              <!-- <v-btn icon @click="closeImageDialog"> -->
                <v-icon @click="closeImageDialog">mdi-close</v-icon>
              <!-- </v-btn> -->
               </v-row>
            </v-card-title>
          </v-card>
            <v-row>
              <v-col v-for="(returnImage, index) in itemData.return_images" cols="3" class="m-3" v-if="itemData && itemData.return_images && itemData.return_images.length > 0">
                <div class="image-container">                
                  <img :src="returnImage" alt="Lot Image" class="image-rad-size" @click="openImagePopupSingle(returnImage)"/>
                </div>
              </v-col>
              <v-col v-for="(image, index) in requestImages" :key="index" cols="3" class="m-3">
                <div class="image-container">                
                  <img :src="image" alt="Lot Image" class="image-rad-size" @click="openImagePopupSingle(image)"/>
                  <div class="cancel-icon" @click="removeImage(index)">
                    <v-icon>mdi-close</v-icon>
                  </div>
                </div>
              </v-col>
            </v-row>
            <span class="pl-3 error-text" style="color:red;" v-if="(requestImages.length > 8) || (itemData && itemData.return_images && itemData.return_images.length > 8) || (requestImages.length + (itemData && itemData.return_images && itemData.return_images.length) > 8) && currentUser.roles[0] === 'area_service_manager'">Only 8 Images can upload.</span>
             <span v-if="(requestImages.length > 8) || (itemData && itemData.return_images && itemData.return_images.length > 8) || (requestImages.length + (itemData && itemData.return_images && itemData.return_images.length) > 8) && currentUser.roles[0] === 'area_service_manager'" class="error-text">
             {{ imageErrorMessage }}
          </span>
          <v-card-text class="mt-3">
            <label for="fileInput" class="icon-container">
              <v-icon class="custom-icon border-icon-style" size="32" color="primary" style="font-weight: bold;">mdi-plus</v-icon>
            </label>
            <input type="file" id="fileInput" ref="fileInput" multiple accept="image/*" :disabled="(requestImages.length >= 8) || (itemData && itemData.return_images && itemData.return_images.length >= 8) || (requestImages.length + (itemData && itemData.return_images && itemData.return_images.length) >= 8) && currentUser.roles[0] === 'area_service_manager'" @change="handleImageUpload1" style="display: none" />
          </v-card-text>
            <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" class="cancel-color mb-3 text-none" @click="closeImageDialog">Cancel</v-btn>
            <v-btn color="primary" variant="flat" @click="submitData" :disabled="isSubmitDisabled" class="mb-3 text-none">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-dialog v-model="imagePopup" max-width="600px">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="imagePopup = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-img :src="selectedImage" width="100%" contain></v-img>
      </v-card>
    </v-dialog>
    <!-- Add Videos Popup -->
    <v-row justify="center">
      <v-dialog v-model="addVideosPopup" persistent max-width="830px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 mt-0">
            <v-card-title>
              <v-row class="ma-1">
              <span>Select Videos</span>
              <v-spacer></v-spacer>
              <!-- <v-btn icon @click="closeVideoDialog"> -->
                <v-icon @click="closeVideoDialog">mdi-close</v-icon>
              <!-- </v-btn> -->
            </v-row>
            </v-card-title>
          </v-card>
          <!-- <v-row> -->
          <!-- <v-col v-for="(returnVideo, index) in itemData.return_videos" cols="3" v-if="itemData && itemData.return_videos && itemData.return_videos.length > 0"> -->
          <!-- Show Loader -->
          <v-row justify="center" v-if="videoLoading">
            <v-col cols="1" class="image-container">
              <v-progress-circular model-value="20" indeterminate color="primary"></v-progress-circular>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col v-for="(returnVideo, index) in itemData.return_videos" :key="index" cols="3">
              <div class="image-container">
                <video controls class="image-rad-size" @click="openVideoPopupSingle(returnVideo)">
                  <source :src="returnVideo">
                </video>
              </div>
            </v-col>
            <v-col v-for="(video, index) in requestVideos" :key="video" cols="3">
              <div class="image-container">                
                <video controls class="image-rad-size" @click="openVideoPopupSingle(video)">
                  <source :src="video">
                </video>
                <div class="cancel-icon" @click="removeVideo(index)">
                  <v-icon>mdi-close</v-icon>
                </div>
              </div>
            </v-col>
          </v-row>
          <!-- <span class="pl-3 error-text" style="color:red;" v-if="requestVideos.length > 2 && currentUser.roles[0] === 'area_service_manager'">Only 2 Videos can upload.</span> -->
          <v-row class="mt-7 ml-3">
            <span class="pl-3 error-text" v-if="currentUser.roles[0] === 'area_service_manager'">
            {{ videoErrorMessage }}
          </span>
          </v-row>
          <v-card-text class="mt-3">    
            <label for="fileInput2" class="icon-container">
              <v-icon color="primary" class="custom-icon border-icon-style" size="32">mdi-plus</v-icon>
            </label>
            <input type="file" id="fileInput2" ref="fileInput2" multiple accept="video/*" :disabled="(requestVideos.length >= 2) || (itemData && itemData.return_videos && itemData.return_videos.length >= 2) || (requestVideos.length + (itemData && itemData.return_videos && itemData.return_videos.length) >= 2) && currentUser.roles[0] === 'area_service_manager'" @change="handleVideoUpload1" style="display: none" />
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" class="cancel-color mb-3 text-none" @click="closeVideoDialog">Cancel</v-btn>
            <v-btn color="primary"  variant="flat" @click="submitData" :disabled="requestVideos.length > 2 && currentUser.roles[0] === 'area_service_manager' || videoErrorMessage != ''" class="mb-3 text-none">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-dialog v-model="videoPopup" max-width="600px">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="videoPopup = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <video :key="selectedVideo" controls width="100%" contain>
          <source :src="selectedVideo">
        </video>
      </v-card>
    </v-dialog>
    <!-- OTP submit popup -->
    <v-row justify="center">
      <v-dialog v-model="enterOtpPopup" persistent max-width="366px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 mt-0 custom-shadow">
                <v-card-title class="pa-0">
                  <v-row class="ma-2">
                  <span class="font-weight-bold">Enter OTP</span>
                  <v-spacer></v-spacer>
                    <v-icon @click="closeEnterOtpPopup">mdi-close</v-icon>
                </v-row>
                </v-card-title>
               </v-card>
          <v-card-text class="pa-0">
            <v-container>
              <v-col cols="6" sm="12" md="12">
                <v-text-field label="Enter OTP" type="number" variant="outlined" v-model="enter_otp" required hide-details></v-text-field>
              </v-col>
              <v-col cols="6" sm="12" md="12" class="pt-0">
                <span class="progressbar">00 : {{ formatTime(timer) }}</span>
                <a href="#"  @click="sentOTP" :class="{ 'disabled-link': isResendDisabled }"
                  style="float:right;color:#2b81d6; cursor: pointer;">Resend OTP
                </a>
              </v-col>
            </v-container>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="outlined" class="mb-3 text-none" @click="closeEnterOtpPopup">Cancel</v-btn>
            <v-btn color="primary" class="mb-3 text-none" @click="verifyOTP" :disabled="!enter_otp" variant="flat">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!--  Success messeage popup -->
    <v-row justify="center">
      <v-dialog v-model="successpopup" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex">
            <v-spacer></v-spacer>
            <v-btn icon @click="successpopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span> {{ successmessage }}</span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="flat" class="mb-3 text-none" @click="afterClickOkLoadData">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- return creation success popup  -->
    <v-row justify="center">
      <v-dialog v-model="returncreateionsuccesspopup" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text class="text-center">
            <span> {{ returncreationsuccessmessage }}</span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" class="mb-3 text-none" @click="redirectToreturncreation" variant="flat">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Search invoice items popup -->
    <v-row justify="center">
      <v-dialog v-model="invoiceItemPopup" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card class="v-card-100 m-0">
          <v-toolbar dark color="primary">
            <v-toolbar-title class="alert-link">{{ invoice_id }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-btn class="blue--text text-none" color="white" :disabled="(this.edit_invoice_selected.length == 0)" small
                @click="addInvoiceItems">Add Items</v-btn>
              <v-btn icon dark @click="closeInvoiceItemPopup"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-actions>
          </v-toolbar>
          <v-layout row>
            <v-data-table dense="true" density="compact" show-select v-model="edit_invoice_selected" :headers="edit_invoice_headers"
              :items="edit_invoice_table_data" :loading="loading" disable-pagination :hide-default-footer="true" loading-text="Loading Data... Please wait"
              class="elevation-1" return-object>
            </v-data-table>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Search lease items popup -->
    <v-row justify="center">
      <v-dialog v-model="leaseItemPopup" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card class="v-card-100 m-0">
          <v-toolbar dark color="primary">
            <v-toolbar-title class="alert-link">{{ lease_id }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-btn class="blue--text text-none" variant="flat" color="white" :disabled="(this.edit_lease_selected.length == 0)" small
                @click="addLeaseItems">Add Items</v-btn>
              <v-btn icon dark @click="closeInvoiceItemPopup"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-actions>
          </v-toolbar>
          <v-layout row>
            <v-data-table :dense="true" show-select v-model="edit_lease_selected" :headers="edit_lease_headers"
              :items="edit_lease_table_data" disable-pagination :hide-default-footer="true" :loading="loading"
              loading-text="Loading Data... Please wait" class="elevation-1" style="overflow:scroll;" return-object>

              <!-- <template v-slot:item.delete="{ item, index }">
                <a href="javascript:void(0)" class="icon">
                  <i v-on:click="removeItem(item, index)" class="fas fa-trash-alt" style="font-size:medium;color:#EC0101;"></i>
                </a>
              </template> -->
            </v-data-table>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- search invoice popup -->
    <v-row justify="center">
      <v-dialog v-model="searchInvoicePopup" persistent max-width="366px" v-if="field_value === 'Invoice'">
        <v-card class="v-card-100">
          <v-card-title class="d-flex">
            <span>Search Invoice</span>
            <v-btn icon color="blue" @click="closeSearchInvoicePopup" style="float:right;">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-actions center>
            <v-col cols="6" sm="12" md="12" style="height: 96px;">
              <v-autocomplete v-model="search_invoice" :items="search_invoice_list" style="margin-bottom: -30px;"
                prepend-inner-icon="mdi-magnify" variant="outlined" item-title="reference_document_number"
                item-value="reference_document_number" label="Search Invoice" class="ma-2"  @update:modelValue="selectInvoiceValue"
                @keyup="searchItems('search_invoice', $event.target.value)">
              </v-autocomplete>
            </v-col>
          </v-card-actions>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" class="mb-3 text-none" variant="flat" :disabled="!search_invoice" @click="openInvoiceItemPopup">Go</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- search lease popup -->
    <v-row justify="center">
      <v-dialog v-model="searchLeaseContractPopup" persistent max-width="366px" v-if="field_value === 'Lease Contract Reference Number'">
        <v-card class="v-card-100">
          <v-card-title class="d-flex">
            <span>Search Reference Number</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeSearchInvoicePopup">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-actions center>
            <v-col cols="6" sm="12" md="12" style="height: 96px;">
              <v-autocomplete v-model="lease_contract_reference_number" :items="lease_contract_reference_number_list" style="margin-bottom: -30px;"
                prepend-inner-icon="mdi-magnify" variant="outlined" item-title="lease_reference_document_number"
                item-value="lease_reference_document_number" label="Enter the Number" class="ma-2"  @update:modelValue="selectInvoiceValue()"
                @keyup="searchItems('lease_reference_document_number', $event.target.value)">
              </v-autocomplete>
            </v-col>
          </v-card-actions>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" class="mb-3 text-none" :disabled="!lease_contract_reference_number" @click="openLeaseReferenceItemPopup" variant="flat">Go</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
     <!--  view error log popup -->
     <v-row justify="center">
      <v-dialog v-model="viewErrorLogPopup" persistent max-width="900px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 mt-0 custom-shadow">
              <v-card-title class="pa-0">
                <v-row class="ma-2">
                  <span class="font-weight-bold">Error Message</span>
                  <v-spacer></v-spacer>
                  <v-icon @click="viewErrorLogPopup = false">mdi-close</v-icon>
                </v-row>
                </v-card-title>
          </v-card>
          <v-card-text class="text-left">
            <!-- <h6>{{this.error_log_data}}</h6> -->
            <v-row>
            <v-col cols="12" sm="3" md="3">
              <strong>Request Payload :</strong>
            </v-col>
             <v-col cols="12" sm="9" md="9">
             {{this.request_log}}
            </v-col>
            </v-row>
            <v-row>
            <v-col cols="12" sm="3" md="3">
             <strong>Response Payload :</strong>
            </v-col>
             <v-col cols="12" sm="9" md="9">
             {{this.response_log}}
            </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="flat" class="mb-3 text-none" @click="viewErrorLogPopup = false">Edit</v-btn>
            <v-btn color="primary" variant="flat" class="mb-3 text-none" @click="submitForm">Re-Trigger</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- return creation form -->
    <v-card class="v-card-100 mt-6">
      <v-card-text>
        <v-row class="returnmb">
          <v-col cols="1" sm="4" md="4" class="text-left">
            <span style="font-weight: 500;">Customer Entity Details</span>
          </v-col>
          <v-col cols="2" sm="4" md="4">
            <v-combobox 
              v-model="customer_name" 
              :items="componentText === 'D2C Sales Return' ? [] : customer_name_list" 
              item-title="original_code"
              :disabled="customer_name_disabled" 
              label="Customer/Entity Name*" 
              variant="outlined" 
              class="ma-2 text-left"
              @update:modelValue="selectInvoiceValue('customer_name')"
              @keyup="searchItems('customer_name', $event.target.value)" 
              return-object 
              color="primary"
              ref="comboboxRef"
              @focus="printWidth"
              :menu-props="{ width: dynamic_width }"
              >
              </v-combobox>
          </v-col>
          <v-col cols="3" sm="4" md="4">
            <v-combobox v-model="customer_type" item-title="original_code" return-object :label="componentText === 'Undelivered Returns Sales Return' || componentText === 'Dealer-Partner Sales Return' ? 'Customer Entity Type' : 'End Customer'" variant="outlined"
              class="ma-2 text-left" :disabled="true" readonly color="primary"></v-combobox>
          </v-col>
        </v-row>
        <v-row class="returnmb">
          <v-col cols="4" sm="4" md="4"> </v-col>
          <v-col cols="5" sm="4" md="4">
            <v-combobox
              v-model="contact_number"
              :items="customer_number_list"
              :disabled="contact_number_disabled"
              item-title="original_code"
              return-object
              label="Contact Number*"
              variant="outlined"
              class="ma-2 text-left"
              @keydown="validateKey"
              @paste="(e) => handlePaste(e, 'contact_number')"
              :rules="[validateContactNumberRule]"
              color="primary"
            ></v-combobox>
          </v-col>

          <v-col cols="6" sm="4" md="4">
            <v-combobox
              v-model="alternate_contact_number"
              item-title="original_code"
              :disabled="alternate_contact_number_disabled"
              label="Alternate Contact Number"
              variant="outlined"
              class="ma-2 text-left"
              @paste="(e) => handlePaste(e, 'alternate_contact_number')"
              @keydown="validateKey"
              :rules="[validateContactNumberRule]"
              color="primary"
            ></v-combobox>
          </v-col>  
        </v-row>
        <v-row class="returnmb">
          <v-col cols="4" sm="4" md="4"> </v-col>
          <v-col cols="8" sm="8" md="8">
            <v-combobox v-model="item_location" :items="item_location_items" :disabled="item_location_disabled"
              item-title="original_code" return-object label="Item Location (Address)*" variant="outlined"
              class="ma-2 text-left" color="primary" ref="comboboxRef1" @focus="printWidth" :menu-props="{ width: dynamic_width }"></v-combobox>
          </v-col>
        </v-row>
        <v-row class="">
          <v-col cols="4" sm="4" md="4"> </v-col>
          <v-col cols="4" sm="4" md="4">
            <v-checkbox v-model="isChecked" label="Different Item Location" :disabled="different_item_location_disabled"  :input-value="active"
              color="primary"></v-checkbox>
          </v-col>
        </v-row>
        <v-row class="returnmb">
          <v-col cols="4" sm="4" md="4"> </v-col>
          <v-col cols="8" sm="8" md="8">
            <v-combobox v-if="isChecked == true" v-model="update_item_location" :disabled="different_item_location_disabled" item-title="original_code" return-object
              label="Update Item Location (Address)*" variant="outlined" class="ma-2 text-left" color="primary"></v-combobox>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="border-top v-card-100 mt-0">
      <v-card-text>
        <v-row class="returnmb" v-for="(itemDetail, index) in itemDetailsFields" :key="index">
          <v-col cols="12" sm="4" md="4" class="text-left" v-if="index===0">
            <span style="font-weight: 500;">Item Details</span>
          </v-col>
          <v-col cols="13" sm="4" md="4" v-if="index===0">
            <v-combobox v-model="itemDetail.updated_by" :items="updated_by_items" :disabled="updated_by_disabled" :item-props="getItemProps"
              item-title="original_code" item-value="id" label="Updated By" variant="outlined" class="ma-2 text-left"
              @update:modelValue="basedOnSelectValue(itemDetail)"  color="primary"></v-combobox>
          </v-col>
          <v-col cols="4" sm="4" md="4" v-if="itemDetail.field_value && index === 0 && (itemDetail.field_value === 'Article ID & Count' || itemDetail.field_value === 'Serial Number')"> </v-col>
          <v-col cols="4" sm="4" md="4" v-if="itemDetail.field_value && (itemDetail.field_value === 'Article ID & Count' || itemDetail.field_value === 'Serial Number')"> </v-col>

          <v-col cols="13" sm="4" md="4" v-if="itemDetail.field_id && (itemDetail.field_value === 'Serial Number') || (itemData.reference_document === 'Serial Number')">
            <v-text-field v-model="itemDetail.serial_number2" label="Serial Number"
              item-title="original_code" item-value="id" variant="outlined" class="ma-2 text-left returnmb" :disabled="serial_number_disabled" color="primary" @keyup="issueReported()"></v-text-field>
          </v-col>
          <v-col cols="13" sm="4" md="4"
            v-if="itemDetail.field_id && (itemDetail.field_value === 'Article ID' || itemDetail.field_value === 'Article ID & Count' || itemDetail.field_value === 'Serial Number') || (itemData.reference_document === 'Article ID & Count' || itemData.reference_document === 'Serial Number')">
            <v-text-field v-model="itemDetail.article_id" label="Article ID"
              item-title="original_code" item-value="id" variant="outlined" class="ma-2 text-left returnmb" :disabled="article_id_disabled" color="primary" @keyup="issueReported()"></v-text-field>
          </v-col>

          <v-col cols="13" sm="4" md="4"
            v-if="itemDetail.field_id && (itemDetail.field_value === 'Count' || itemDetail.field_value === 'Article ID & Count') || (itemData.reference_document === 'Article ID & Count')">
            <v-text-field v-model="itemDetail.count" label="Count" item-title="original_code" :disabled="count_disabled" item-value="id" variant="outlined"
              class="ma-2 text-left" color="primary" @change="updateIds(itemDetail)"></v-text-field>
          </v-col>

          <v-col cols="13" sm="4" md="4" v-if="itemDetail.field_value === 'Article ID & Count' || itemDetail.field_value === 'Serial Number'"> </v-col>
          <v-col cols="13" sm="4" md="4" v-if="itemDetail.field_id && (itemDetail.field_value === 'Serial Number') || (itemData.reference_document === 'Serial Number' && itemData.tag_number)">
            <v-text-field v-model="itemDetail.tag_ids" label="Add Tag ID"
              item-title="original_code" item-value="id" variant="outlined" class="ma-2 text-left" :disabled="article_id_disabled" color="primary"></v-text-field>
          </v-col>
          <v-col cols="13" sm="4" md="4"
            v-if="itemDetail.field_id && (itemDetail.field_value === 'Serial Number') || (itemData.reference_document === 'Serial Number' && itemData.box_id)">
            <v-text-field v-model="itemDetail.box_ids" label="Add Box ID"
              item-title="original_code" item-value="id" variant="outlined" class="ma-2 text-left " :disabled="article_id_disabled" color="primary"></v-text-field>
          </v-col>

          <template v-if="(itemDetail.field_id && itemDetail.field_value === 'Article ID & Count' && itemDetail.count > 0) || (itemData.reference_document === 'Article ID & Count')" class="returnmb">            
            <template v-for="index in Number(itemDetail.count)" :key="`pair-${index}`" class="returnmb">
              <v-col cols="4" sm="4" md="4" v-if="index > 1"> </v-col>
              <v-col cols="13" sm="4" md="4">
                <v-text-field
                  v-model="itemDetail.tag_ids[index - 1]"
                  :label="`Add Tag ID ${index}`"
                  variant="outlined"
                  class="ma-2 text-left"
                  :disabled="article_id_disabled"
                  color="primary"
                />
              </v-col>
              <v-col cols="13" sm="4" md="4">
                <v-text-field
                  v-model="itemDetail.box_ids[index - 1]"
                  :label="`Add Box ID ${index}`"
                  variant="outlined"
                  class="ma-2 text-left"
                  :disabled="article_id_disabled"
                  color="primary"
                />
              </v-col>
            </template>
          </template>

          <v-col cols="13" sm="4" md="4" v-if="itemDetail.field_id && itemDetail.field_value === 'Invoice' || (itemDetail.field_value === 'Invoice' && itemData.reference_document === 'Invoice')">
            <v-combobox v-model="searched_invoice" item-title="original_code" item-value="id" label="Invoice Number" outlined class="ma-2 text-left" :disabled="invoice_disabled" readonly color="primary"></v-combobox>
          </v-col>
          <v-col cols="13" sm="4" md="4" v-if="itemDetail.field_id && itemDetail.field_value === 'Vendor Reference Code' || (itemDetail.field_value === 'Vendor Reference Code' && itemData.reference_document === 'Vendor Reference Code')">
            <v-combobox v-model="itemDetail.vendor_reference_code" :items="vendor_reference_code_list"
              label="Vendor Reference Code" item-title="original_code" item-value="id"
              @update:modelValue="basedOnSelectValue(itemDetail)"
              @keyup="searchItems('vendor_reference_code', $event.target.value)" variant="outlined" class="ma-2 text-left" :disabled="vendor_reference_code_disabled" color="primary"></v-combobox>
          </v-col>
          <!-- <v-col cols="13" sm="4" md="4" v-if="field_id && field_value === 'Lease Contract Reference Number'">
            <v-text-field v-model="itemDetail.lease_contract_reference_number" label="Lease Contract Reference Number"
              item-title="original_code" item-value="id" variant="outlined" class="ma-2"></v-text-field>
          </v-col> -->
        </v-row>
        <v-row v-for="(item, rowIndex) in edit_invoice_selected" :key="'row_' + rowIndex"
          v-if="getMatchingItemDetail(item)">
          <v-col cols="4" sm="4" md="4"></v-col>
          <v-col cols="13" sm="4" md="4">
            <v-text-field v-model="item.sku_code" label="Article ID" item-title="sku_code"
              item-value="id" variant="outlined" class="text-left" color="primary"></v-text-field>
          </v-col>
          <v-col cols="13" sm="4" md="4">
            <v-text-field v-model="item.serial_number" label="Serial Number" item-title="serial_number"
              item-value="id" variant="outlined" class="text-left" color="primary"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4" sm="4" md="4"> </v-col>
          <v-col cols="4" sm="4" md="4" class="text-left">
            <v-btn class="ma-2 color-change text-none" @click="handleAddMoreItems" color="#ffff" :disabled="disabledAddMore" variant="flat">+ Add More
              Items</v-btn>
          </v-col>
        </v-row>
        <!-- <v-row class="returnmb">
          <v-col cols="4" sm="4" md="4" > </v-col>
          <v-col cols="5" sm="4" md="4" >
            <v-combobox v-model="article_id" item-title="original_code" return-object label="Article ID being sold on exchange" variant="outlined" class="ma-2"></v-combobox>
          </v-col>
          <v-col cols="6" sm="4" md="4" >
            <v-combobox v-model="article_description" item-title="original_code" item-value="" label="Article Description" variant="outlined" class="ma-2"></v-combobox>
          </v-col>
        </v-row> -->
      </v-card-text>
    </v-card>
    <v-card class="border-top v-card-100 mt-0" v-if="this.componentText === 'Internal Returns'">
      <v-card-text>
        <v-row class="returnmb">
          <v-col cols="12" sm="4" md="4" class="text-left">
            <span style="font-weight: 500;">Analytical Details</span>
          </v-col>
          <v-col cols="13" sm="4" md="4" >
            <v-combobox v-model="channel" :items="channel_items" item-title="original_code" item-value="id" return-object label="Channel" variant="outlined" class="ma-2 text-left" color="primary"></v-combobox>
          </v-col>
        </v-row>
        <v-row class="returnmb">
          <v-col cols="4" sm="4" md="4" > </v-col>
          <v-col cols="13" sm="4" md="4" >
            <v-combobox v-model="return_request_subtype" :items="return_request_subtype_items" item-title="original_code" item-value="id" 
             return-object label="Return Reqeust Sub-type" variant="outlined" class="ma-2 text-left" color="primary" @update:modelValue="returnreason"  :disabled="currentUser.roles[0] === 'area_service_manager'"></v-combobox>
          </v-col>
          <v-col cols="5" sm="4" md="4" >
            <v-combobox v-model="return_reason" :items="return_reason_items" item-title="original_code" 
            item-value="id" return-object label="Return Reason" variant="outlined" class="ma-2 text-left" :disabled="return_request_subtype == ''" color="primary" @update:modelValue="returnSubReason"></v-combobox>
          </v-col>
        </v-row>
        <v-row class="returnmb">
          <v-col cols="4" sm="4" md="4" > </v-col>
          <v-col cols="6" sm="4" md="4" >
            <v-combobox v-model="retrun_sub_reason" :items="retrun_sub_reason_itmes" item-title="original_code" item-value="id" label="Return Sub-Reason" variant="outlined" class="ma-2 text-left" :disabled="return_reason == ''" color="primary"></v-combobox>
          </v-col>
          <v-col cols="5" sm="4" md="4" >
            <v-text-field v-model="item_location2" :items="item_location_items2" 
             item-title="original_code" item-value="id" return-object label="Item Location" 
             variant="outlined" class="ma-2 text-left" :disabled="return_request_subtype == ''" color="primary" @update:modelValue="returnSubReason"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="returnmb">
          <v-col cols="4" sm="4" md="4" > </v-col>
          <v-col cols="6" sm="4" md="4" >
            <v-combobox v-model="type_of_incident_or_damage2" :items="type_of_incident_or_damage2_itmes" item-title="original_code" item-value="id" label="Type of Incident/Damage" variant="outlined" class="ma-2 text-left" color="primary" :disabled="return_reason == ''" ></v-combobox>
          </v-col>
          <v-col cols="5" sm="4" md="4" >
            <v-combobox v-model="type_of_loss" :items="type_of_loss_items" item-title="original_code" item-value="id" return-object label="Type of Loss" 
             variant="outlined" class="ma-2 text-left" color="primary" :disabled="return_request_subtype == ''"  @update:modelValue="returnSubReason"></v-combobox>
          </v-col>
        </v-row>
        <v-row class="returnmb">
          <v-col cols="4" sm="4" md="4" > </v-col>
          <v-col cols="6" sm="4" md="4" >
            <v-text-field v-model="estimated_loss" :items="estimated_loss_items" item-title="original_code" item-value="id" label="Estimated Loss" variant="outlined" class="ma-2 text-left" :disabled="return_reason == ''" color="primary"></v-text-field>
          </v-col>
          <v-col cols="5" sm="4" md="4" >
            <v-text-field v-model="salvage_value" :items="salvage_value_items" item-title="original_code" 
             item-value="id" return-object label="Salvage Value" variant="outlined" class="ma-2 text-left" :disabled="return_request_subtype == ''" color="primary" @update:modelValue="returnSubReason"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="returnmb">
          <v-col cols="4" sm="4" md="4" > </v-col>
          <v-col cols="6" sm="4" md="4" >
            <v-text-field v-model="incident_date" item-title="original_code" item-value="id" label="Incident Date" variant="outlined" class="ma-2 text-left" :disabled="return_reason == ''" color="primary"></v-text-field>
          </v-col>
          <v-col cols="5" sm="4" md="4" >
            <v-text-field v-model="incident_location" item-title="original_code" item-value="id" return-object label="Incident Location" variant="outlined" class="ma-2 text-left" :disabled="return_request_subtype == ''" color="primary" @update:modelValue="returnSubReason"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="returnmb">
          <v-col cols="4" sm="4" md="4" > </v-col>
          <v-col cols="6" sm="4" md="4" >
            <v-combobox v-model="vendor_responsible2" item-title="original_code" item-value="id" label="Vendor Responsible" variant="outlined" class="ma-2 text-left" color="primary" :disabled="return_reason == ''" ></v-combobox>
          </v-col>
          <v-col cols="5" sm="4" md="4" >
            <v-text-field v-model="incident_report_number" item-title="original_code" item-value="id" return-object label="Incident Report Number" variant="outlined" class="ma-2 text-left" color="primary" :disabled="return_request_subtype == ''"  @update:modelValue="returnSubReason"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="returnmb">
          <v-col cols="4" sm="4" md="4" > </v-col>
          <v-col cols="6" sm="4" md="4" >
            <v-text-field v-model="damage_certificate" item-title="original_code" item-value="id" label="Damage Certificate/COF" variant="outlined" class="ma-2 text-left" color="primary" :disabled="return_reason == ''" ></v-text-field>
          </v-col>
          <v-col cols="5" sm="4" md="4" >
            <v-text-field v-model="incident_report" item-title="original_code" item-value="id" return-object label="Incident Report" variant="outlined" class="ma-2 text-left" color="primary" :disabled="return_request_subtype == ''"  @update:modelValue="returnSubReason"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="border-top v-card-100 mt-0" v-if="this.componentText !== 'Internal Returns'">
      <v-card-text>
        <v-row class="returnmb">
          <v-col cols="12" sm="4" md="4" class="text-left">
            <span style="font-weight: 500;">Analytical Details</span>
          </v-col>
          <v-col cols="13" sm="4" md="4">
            <v-combobox v-model="channel" :items="channel_items" item-title="original_code" item-value="id" return-object
              label="Channel" variant="outlined" class="ma-2 text-left" color="primary"  @update:modelValue="clearIfNotSelected('channel', 'channel_items', 'clearChannel')" ref="clearChannel"></v-combobox>
          </v-col>
          <v-col cols="13" sm="4" md="4">
            <v-combobox v-model="return_request_subtype" :items="return_request_subtype_items" :item-title="$store.state.actionRequest === 'requested' ? 'original_code' : 'original_code'"
             :item-value="$store.state.actionRequest === 'id' ? 'code' : 'id'" return-object label="Return Subtype" color="primary" variant="outlined" class="ma-2 text-left"
              @update:modelValue="returnreason" @blur="clearIfNotSelected('return_request_subtype', 'return_request_subtype_items', 'clearSubType')" ref="clearSubType"></v-combobox>
          </v-col>
        </v-row>
        <v-row class="returnmb">
          <v-col cols="4" sm="4" md="4"> </v-col>
          <v-col cols="5" sm="4" md="4">
            <v-combobox v-model="return_reason" :items="return_reason_items" :item-title="$store.state.actionRequest === 'requested' ? 'original_code' : 'original_code'"
             :item-value="$store.state.actionRequest === 'id' ? 'code' : 'id'"              
              return-object label="Return Reason" variant="outlined" class="ma-2 text-left"  color="primary"
              @update:modelValue="returnSubReason" @blur="clearIfNotSelected('return_reason', 'return_reason_items', 'returnReasonCombobox')" ref="returnReasonCombobox"></v-combobox>
          </v-col>
          <v-col cols="6" sm="4" md="4">
            <v-combobox v-model="retrun_sub_reason" :items="retrun_sub_reason_itmes" :item-title="$store.state.actionRequest === 'requested' ? 'original_code' : 'original_code'"
              :item-value="$store.state.actionRequest === 'requested' ? 'id' : 'id'" label="Return Sub-Reason" variant="outlined" class="ma-2 text-left" color="primary"
              ></v-combobox>
          </v-col>
        </v-row>
        <v-row class="returnmb">
          <v-col cols="4" sm="4" md="4"> </v-col>
          <v-col cols="5" sm="4" md="4">
            <v-text-field prepend-inner-icon="mdi-magnify"  v-model="client_crm_ticket_no" label="CRM Ticket No."  class="ma-2" variant="outlined"></v-text-field>
          </v-col>
          <v-col cols="5" sm="4" md="4">
            <v-text-field prepend-inner-icon="mdi-magnify"  v-model="tag_id" label="Tag ID"  class="ma-2" variant="outlined"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="returnmb">
          <v-col cols="4" sm="4" md="4"> </v-col> 
          <v-col cols="6" sm="4" md="4">
            <v-menu
                  ref="menu3"
                  v-model="menu3"
                  :close-on-content-click="false"
                  :return-value.sync="tag_id_date"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ props }">
                    <v-text-field
                      variant="outlined"
                      v-model="formattedTagDate"
                      label="Tag ID Date"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="props"
                      class="ma-2"
                    ></v-text-field>
                  </template>
                  <v-card class="m-0 overflow-hidden calendar-layout" width="315">
                    <v-date-picker v-model="tag_id_date" hide-header color="primary" min-width="200" no-title
                      scrollable>
                    </v-date-picker>
                    <v-card-action class="d-flex justify-end pb-3">
                      <v-spacer></v-spacer>
                      <v-btn variant="text" class="text-none " color="primary" @click="cancelExpiryDate">Cancel</v-btn>
                      <v-btn variant="text" class="text-none " color="primary" @click="menu3 = false">Ok</v-btn>
                    </v-card-action>
                  </v-card>
                </v-menu>
          </v-col>         
          <v-col cols="6" sm="4" md="4">
            <v-menu
                  ref="menu4"
                  v-model="menu4"
                  :close-on-content-click="false"
                  :return-value.sync="manufacture_date"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ props }">
                    <v-text-field
                      variant="outlined"
                      v-model="formattedManufactureDate"
                      label="Manufacturing Date"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="props"
                      class="ma-2"
                    ></v-text-field>
                  </template>
                  <v-card class="m-0 overflow-hidden calendar-layout" width="315">
                    <v-date-picker :max="new Date().toISOString().substr(0, 10)" v-model="manufacture_date" hide-header color="primary" min-width="200" no-title
                      scrollable>
                    </v-date-picker>
                    <v-card-action class="d-flex justify-end pb-3">
                      <v-spacer></v-spacer>
                      <v-btn variant="text" class="text-none " color="primary" @click="cancelManufactureDate">Cancel</v-btn>
                      <v-btn variant="text" class="text-none " color="primary" @click="menu4 = false">Ok</v-btn>
                    </v-card-action>
                  </v-card>
                </v-menu>
          </v-col>
        </v-row>
         <v-row class="returnmb">
          <v-col cols="4" sm="4" md="4"> </v-col>
          <v-col cols="5" sm="4" md="4">
            <v-text-field prepend-inner-icon="mdi-magnify"  v-model="batch" label="Batch"  class="ma-2" variant="outlined"></v-text-field>
          </v-col>
          <v-col cols="5" sm="4" md="4">
            <v-text-field prepend-inner-icon="mdi-magnify"  v-model="vendor_value" label="Vendor"  class="ma-2" variant="outlined"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="border-top v-card-100 mt-0">
      <v-card-text>
        <v-row class="returnmb">
          <v-col cols="12" sm="4" md="4" class="text-left">
            <span style="font-weight: 500;">Customer Declaration</span>
          </v-col>
          <v-col cols="13" sm="4" md="4">
            <v-combobox v-model="issue_reported" :items="issue_reported_items" item-title="mapping_value" item-value="id"
              return-object label="Issue Reported" variant="outlined" class="ma-2 text-left" color="primary"></v-combobox>
          </v-col>
          <v-col cols="13" sm="4" md="4">
            <v-combobox v-model="type_of_damage" :items="type_of_damage_items" item-title="original_code" item-value="id"
              return-object label="Type of Damage" variant="outlined" class="ma-2 text-left" color="primary"></v-combobox>
          </v-col>
        </v-row>
        <v-row class="returnmb">
          <v-col cols="4" sm="4" md="4"> </v-col>
          <v-col cols="5" sm="4" md="4">
            <v-combobox v-model="responsible_for_damage" :items="responsible_for_damage_items" item-title="original_code"
              item-value="id" return-object label="Vendor responsible for damage" variant="outlined" class="ma-2 text-left" color="primary"></v-combobox>
          </v-col>
        </v-row>
        <!-- <v-row style="margin-bottom: -20px;"> 
          <v-col cols="12" sm="4" md="4" > </v-col>
          <v-col cols="13" sm="4" md="4" >
            <v-btn class="ma-2 color-change" @click="addSerialNumber" color="#ffff">DECLARE CONDITIONS</v-btn>
          </v-col>
        </v-row> -->
        <v-row class="returnmb" v-if="this.componentText === 'Warranty Claim' || this.componentText === 'Exchange (Trade-In) Return' || this.componentText === 'Dealer-Partner Sales Return'">
          <v-col cols="12" sm="4" md="4"></v-col>
          <v-col cols="8" sm="4" md="4" >
            <!--<v-file-input v-model="file" accept= "image/*" multiple chips show-chips :label="'Images Max (' + (itemData && itemData.return_images ? (8 - itemData.return_images.length) : '8') + ')'" class="ma-2" :disabled="image_disabled"  @update:modelValue="handleFileChange" :error-messages="imageErrorMessage" v-if="this.currentUser.roles[0] === 'area_service_manager'"></v-file-input>
            <v-file-input v-model="file" accept= "" label="Images" class="ma-2" :disabled="image_disabled" v-else></v-file-input>
          -->
            <v-expansion-panels class="custom-control_outlined" ref="imagepopup" readonly style="max-width: 100% !important;" :disabled="image_disabled" v-if="this.currentUser.roles[0] === 'area_service_manager'">
              <v-expansion-panel variant="outlined" class="p-3"  @click="openImagePopup">
                <v-expansion-panel-header>Images (Max {{ itemData && itemData.return_images ? (8 - itemData.return_images.length) : '8' }})
                  <template v-slot:actions>
                    <v-icon>
                      mdi-attachment
                    </v-icon>
                  </template>
                </v-expansion-panel-header>
                </v-expansion-panel>
            </v-expansion-panels>
            <span v-if="this.currentUser.roles[0] === 'area_service_manager'" class="error-text">
              {{ imageErrorMessage }}
            </span>
            <v-expansion-panels class="custom-control_outlined" ref="imagepopup" readonly style="max-width: 100% !important;" v-else>
              <v-expansion-panel variant="outlined"  class="p-3" @click="openImagePopup">
                <v-expansion-panel-header>Images
                  <template v-slot:actions>
                    <v-icon>
                      mdi-attachment
                    </v-icon>
                  </template>
                </v-expansion-panel-header>
                </v-expansion-panel>
            </v-expansion-panels>
            <span style="float:left;">
              Images attached: 
              {{ isImagesAttached }} 
            </span>
          </v-col>
          <v-col cols="9" sm="4" md="4" >
            <!--<v-file-input v-model="file_video" accept= "video/*" multiple chips show-chips label="Videos Max(2)" class="ma-2" :disabled="video_disabled"  @update:modelValue="validateVideoDuration" :error-messages="videoErrorMessage" v-if="this.currentUser.roles[0] === 'area_service_manager'"></v-file-input>
            <v-file-input v-model="file_video" accept= "" label="Videos" class="ma-2" :disabled="video_disabled" v-else></v-file-input>-->
            <v-expansion-panels class="custom-control_outlined" ref = "videopopup" readonly style="max-width: 100% !important;" :disabled="video_disabled" :error-messages="videoErrorMessage" v-if="this.currentUser.roles[0] === 'area_service_manager'">
              <v-expansion-panel disab variant="outlined" class="p-3"  @click="openVideosPopup">
                <v-expansion-panel-header>Videos (Max {{ itemData && itemData.return_videos ? (2 - itemData.return_videos.length) : '2' }})
                  <template v-slot:actions>
                  <v-icon>
                    mdi-attachment
                  </v-icon>
                  </template>
                </v-expansion-panel-header>
              </v-expansion-panel>
            </v-expansion-panels>
            
            <span class="error-text" v-if="this.currentUser.roles[0] === 'area_service_manager'">
              {{ videoErrorMessage }}
            </span>
            <v-expansion-panels class="custom-control_outlined" ref = "videopopup" readonly style="max-width: 100% !important;" v-else>
              <v-expansion-panel disab variant="outlined" class="p-3"  @click="openVideosPopup">
                <v-expansion-panel-header>Videos
                  <template v-slot:actions>
                  <v-icon>
                    mdi-attachment
                  </v-icon>
                  </template>
                </v-expansion-panel-header>
              </v-expansion-panel>
            </v-expansion-panels>
            <span style="float:left;">
              Videos attached: 
                {{isVideosAttached}}  
            </span>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="itemData == '' && componentText !== 'Undelivered Returns Sales Return' && componentText !== 'E-Commerce Returns Sales Return'" class="request_creation_disabled text-left text-none" size="small" color="primary" style="margin-top: 18px;" :disabled="!isFormValid" @click="submitForm" variant="flat">Submit</v-btn>
          <v-btn v-if="itemData == '' && componentText === 'Undelivered Returns Sales Return' || itemData == '' && componentText === 'E-Commerce Returns Sales Return'" class="request_creation_disabled text-left text-none" size="small" color="primary" style="margin-top: 18px;" :disabled="!isFormValid" @click="submitForm" variant="flat">Submit</v-btn>
          <v-btn v-if="itemData.stage === 'Ticket'" class="return_item_ticket_disabled text-left text-none" size="small" color="primary" style="margin-top: 18px;" @click="updateReturnItemTicket" :disabled="!isFormValid2" variant="flat">Submit</v-btn>
          <v-btn v-if="itemData.stage === 'Request'" class="request_item_disabled text-left text-none" size="small" color="primary" style="margin-top: 18px;" @click="updateRequestItem" :disabled="!isFormValid2" variant="flat">Submit</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
import HeaderComponent from '../../../commoncomponents/HeaderComponent.vue';
import { NumberValidation } from '../../../commoncomponents/NumberValidation';
import Loading from 'vue-loading-overlay';

export default {
  mixins: [NumberValidation],
  data() {
    return {
      headerText: "Return Creation",
      alert_type: 'success',
      alert_message: 'success',
      return_search: '',
      alert: false,
      timeout: 2000,
      isLoading: false,
      mainFullPage : true,
      selected: [],
      requestImages: [],
      requestVideos: [],
      imagePopup: false,
      videoPopup: false,
      selectedImage: '',
      selectedVideo: '',
      requestImageNames:[],
      requestVideosNames:[],
      requestImagesUrl:[],
      requestVideosUrl: [],
      temprequestImagesUrl : [],
      temprequestVideosUrl: [],
      requestImagesFileFormat:[],
      requestVideosFileFormat: [],
      temprequestImagesFileFormat : [],
      temprequestVideosFileFormat : [],
      removedImages:[],
      removedVideos:[],
      tempRemovedImages : [],
      tempRemovedVideos : [],
      initialrequestImagesLength: 0,
      initialrequestVideosLength: 0,
      primary_code: "#0275d8",
      fullPage : true,
      biddingMethod:'',
      mrp_value : '',
      selectedImages:[],
      temp_lotImages : '',
      temp_requestImageNames : '',
      temp_requestImagesFileFormat : '', 
      searchInvoicePopup: true,
      searchLeaseContractPopup: true,
      edit_invoice_selected: [],
      edit_lease_selected: [],
      edit_invoice_headers: [],
      edit_lease_headers: [],
      edit_invoice_table_data: [],
      edit_lease_table_data: [],
      search_invoice: '',
      searched_invoice : '',
      lease_contract_reference_number: '',
      search_invoice_list: [],
      lease_contract_reference_number_list: [],
      invoiceItemPopup: false,
      leaseItemPopup: false,
      customer_name: '',
      searched_customer_name: '',
      customer_name_list: [],
      customer_number_list: [],
      serial_number_list: [],
      article_id_list: [],
      vendor_reference_code_list: [],
      file: [],
      file_video: [],
      itemDetailsFields: [
        {
          field_id : '',
          field_value : '',
          document_number: '',
          article_id: '',
          serial_number2: '',
          invoice_number: '',
          count: '',
          box_ids: [],
          tag_ids: [],
          weatherData: null,
          articleId: null,
          updated_by: null,
          vendor_reference_code: ''
        }
      ],
      disabledAddMore: true,
      showError: false,
      updated_by_items: [],
      number: 0,
      returncreationsuccessmessage: '',
      returncreateionsuccesspopup: false,
      successpopup: false,
      successmessage: '',
      serial_number: '',
      active: '',
      customer_type: '',
      contact_number: '',
      alternate_contact_number: '',
      item_location: '',
      isChecked: false,
      update_item_location: null,
      channel: '',
      return_request_subtype: null,
      return_reason: null,
      retrun_sub_reason: null,
      issue_reported: null,
      type_of_damage: null,
      responsible_for_damage: '',
      responsible_for_damage_items: [],
      enter_otp: '',
      disabled: false,
      item_location_items: [],
      channel_items: [],
      return_reason_items: [],
      return_request_subtype_items: [],
      retrun_sub_reason_itmes: [],
      issue_reported_items: [],
      type_of_damage_items: [],
      enterOtpPopup: false,
      returnTypeList: [],
      createRequest: '',
      loading: false,
      page: 1,
      totalPages: 1,
      pageSize: 100,
      pageSizes: [50, 100, 150],
      field_value: '',
      field_id: '',
      reference_document_number: '',
      search_return_items: [],
      item_id: '',
      otp_message: '',
      otp_verification_details: [],
      sku_code: '',
      is_different_location: false,
      invoice_id: '',
      lease_id: '',
      invoice_value: '',
      invoice_ids: '',
      article_value: '',
      vendor_reference_code_value: '',
      count_value: '',
      serial_number_value: '',
      return_inventory_information_id: '',
      returntype: '',
      returnvalue: '',
      itemData: [],
      customer_name_disabled: false,
      contact_number_disabled: false,
      item_location_disabled: false,
      different_item_location_disabled: false,
      alternate_contact_number_disabled: false,
      updated_by_disabled: false,
      serial_number_disabled: false,
      count_disabled: false,
      article_id_disabled: false,
      invoice_disabled: true,
      vendor_reference_code_disabled: false,
      image_disabled: false,
      video_disabled: false,
      hideReturnCreation: true,
      showReturnItemTicket: false,
      showRequestITem: false,
      path: '',
      currentUser:'',
      imageErrorMessage: '',
      videoErrorMessage: '',
      addImagesPopup: false,
      addVideosPopup: false,
      uploadingImgFile: [],
      uploadingVidFile: [],
      submittedData: [],
      clientID: '',
      branch: '',
      viewErrorLogPopup:false,
      request_log:'',
      response_log:'',
      videoLoading:false,
      dynamic_width:'',
      tag_id_date:null,
      menu3: false,
      tag_id: null,
      client_crm_ticket_no: null,
      menu4: false,
      manufacture_date: null,
      batch: null,
      vendor_value: '',
      organization_name: '',
    }

  },
  components: {
    HeaderComponent,Loading
  },
  computed: {
    isResendDisabled() {
      return this.timer > 0;
    },
    isFormValid() {
      const hasValidFields = this.itemDetailsFields.some(item => {
        return this.updated_by_items.some(requiredField => {
          switch (requiredField.original_code) {
            case 'Serial Number':
              return item.serial_number2 && this.customer_name && this.contact_number && this.item_location;
            case 'Invoice':
              return this.search_invoice && this.customer_name && this.contact_number && this.item_location;
            case 'Count':
              return item.count && this.customer_name && this.contact_number && this.item_location;
            case 'Article ID & Count':
              return item.article_id && item.count && this.customer_name && this.contact_number && this.item_location;
            case 'Vendor Reference Code':
              return item.vendor_reference_code && this.customer_name && this.contact_number && this.item_location;
            default:
              return false;
          }
        });
      });
      const hasErrors = this.imageErrorMessage || this.videoErrorMessage;
      return hasValidFields && !hasErrors;
    },
    isFormValid2(){
      const hasErrors = this.imageErrorMessage || this.videoErrorMessage;
      return !hasErrors;
    },
    isSubmitDisabled() {
      const maxImages = 8;
      const isManager = this.currentUser.roles[0] === 'area_service_manager';
      
      const itemImagesCount = this.itemData && this.itemData.return_images ? this.itemData.return_images.length : 0;
      const requestImagesCount = this.requestImages ? this.requestImages.length : 0;
      
      const totalImages = itemImagesCount + requestImagesCount;
      return (isManager && totalImages > maxImages);
    },
    isImagesAttached() {
      const maxImages = 8;
      const isManager = this.currentUser.roles[0] === 'area_service_manager';
      const itemImagesCount = this.itemData && this.itemData.return_images ? this.itemData.return_images.length : 0;
      const requestImagesCount = this.requestImages ? this.requestImages.length : 0;
      let totalImages = itemImagesCount + requestImagesCount;
  
      if (totalImages > maxImages) {
        totalImages = maxImages;
      }

      if (isManager) {
        if (itemImagesCount > 0) {
          return `${itemImagesCount} of ${maxImages}`;
        }
        return `${totalImages} of ${maxImages}`;
      }else if(!isManager){
        if (itemImagesCount > 0 && requestImagesCount === 0) {
          return `${itemImagesCount}`;
        }
        return `${totalImages} of ${maxImages}`;
      }
      return requestImagesCount;
    },
    isVideosAttached(){
      const maxVideos = 2;
      const isManager = this.currentUser.roles[0] === 'area_service_manager';
      const itemVideosCount = this.itemData && this.itemData.return_videos ? this.itemData.return_videos.length : 0;
      const requestVideosCount = this.requestVideos ? this.requestVideos.length : 0;
      let totalVideos = itemVideosCount + requestVideosCount;
  
      if (totalVideos > maxVideos) {
        totalVideos = maxVideos;
      }

      if (isManager) {
        if (itemVideosCount > 0) {
          return `${itemVideosCount} of ${maxVideos}`;
        }
        return `${totalVideos} of ${maxVideos}`;
      }else{
        if (itemVideosCount > 0 && requestVideosCount === 0) {
          return `${itemVideosCount}`;
        }
        return `${totalVideos} of ${maxVideos}`;
      }
    },
    formattedTagDate() {
        return this.formatDate(this.tag_id_date);
      },
      formattedManufactureDate() {
        return this.formatDate(this.manufacture_date);
      }
  },
  watch: {
    itemDetailsFields: {
      handler(newVal) {
        const lastItem = newVal[newVal.length - 1];
        if (lastItem && lastItem.updated_by?.original_code === 'Serial Number' || !this.itemData) {
          this.disabledAddMore = false;
        } else {
          this.disabledAddMore = true;
        }
      },
      deep: true,
      immediate: true
    }
  },
  async created() {
    this.field_value = localStorage.getItem('field_value');
    this.organization_name = this.$store.state.organization_name;
    this.returntype = this.$store.state.lotIds;
    this.returnvalue = this.$store.state.action;
    this.currentUser = this.$store.state.currentUser;
    if (this.$store.state.items !== '') {
      this.itemData = JSON.parse(this.$store.state.items);
      this.action = this.$store.state.actionRequest;
    }
    if(this.itemData == ''){
      this.fetchAllData(this.returntype, this.returntype);
    }else if(this.$store.state.actionRequest === 'requested'){
      this.fetchAllData(this.itemData.return_type_id, this.itemData.id);
    }
    this.componentText = this.returnvalue || this.itemData.return_type
    if(this.componentText === 'Undelivered Returns Sales Return' || this.componentText === 'Dealer-Partner Sales Return'){
      this.customer_type = 'Dealer'
    }else {
      this.customer_type = 'End Customer'
    }
    this.Fetchallapis();
    this.fetchSearchData();
    if(this.itemData) {
      if(this.itemData.stage === 'Request'){
        this.customer_name_disabled = true;
        this.contact_number_disabled = true;
        this.item_location_disabled = true;
        this.different_item_location_disabled = true;
        this.alternate_contact_number_disabled = true;
        this.updated_by_disabled = true;
        this.serial_number_disabled = true;
        this.count_disabled = true;
        this.article_id_disabled = true;
        this.invoice_disabled = true;
        this.vendor_reference_code_disabled = true;
        if(this.itemData.status !== 'Pending Approval' && this.itemData.status !== 'Pending Testing'){
          this.image_disabled = true;
          this.video_disabled = true;
        }
        this.showRequestItem = true;
        this.hideReturnCreation = false;
      }else if(this.itemData.stage === 'Ticket'){
        this.customer_name_disabled = true;
        this.contact_number_disabled = true;
        this.item_location_disabled = true;
        this.different_item_location_disabled = true;
        this.alternate_contact_number_disabled = true;
        if(this.itemData.status !== 'Pending Approval' && this.itemData.status !== 'Pending Testing'){
          this.image_disabled = true;
          this.video_disabled = true;
        }
        this.showReturnItemTicket = true;
        this.hideReturnCreation = false;
      }

      this.searched_customer_name = this.customer_name = this.itemData.customer_name;
      this.contact_number = this.itemData.contact_number;
      if(this.itemData.customer_item_location && this.itemData.is_different_location === true){
        this.isChecked = true;
        this.item_location = this.itemData.customer_item_location;
        this.update_item_location = this.itemData.item_location
      }else {
        this.item_location = this.itemData.item_location;
      }
      this.alternate_contact_number = this.itemData.alternate_contact_number;
      this.itemDetailsFields.find(item => {
        if(this.itemData.reference_document === 'Invoice'){
          item.updated_by = this.itemData.reference_document;
          this.searched_invoice = this.search_invoice = this.itemData.reference_document_number
          item.field_value = this.itemData.reference_document;
        }else if (this.itemData.reference_document === 'Serial Number'){
          item.updated_by = this.itemData.reference_document;
          item.serial_number2 = this.itemData.reference_document_number
          item.field_value = this.itemData.reference_document;
          item.article_id = this.itemData.sku_code
          item.tag_ids = this.itemData.tag_number
          item.box_ids = this.itemData.box_id
        }else if (this.itemData.reference_document === 'Article ID & Count'){
          item.updated_by = this.itemData.reference_document;
          item.article_id = this.itemData.reference_document_number
          item.field_value = this.itemData.reference_document;
          const tagList = this.normalizeToArray(this.itemData.tag_number);
          const boxList = this.normalizeToArray(this.itemData.box_id);

          item.tag_ids = tagList;
          item.box_ids = boxList;
          item.count = tagList.length;
        }else if (this.itemData.reference_document === 'Vendor Reference Code'){
          item.updated_by = this.itemData.reference_document;
          item.vendor_reference_code = this.itemData.reference_document_number
          item.field_value = this.itemData.reference_document;
        }else if (this.itemData.reference_document === 'Count'){
          item.updated_by = this.itemData.reference_document;
          item.field_value = this.itemData.reference_document;
          item.count = this.itemData.reference_document_details.count
        }
      });
      this.channel = this.itemData.channel ? this.itemData.channel : null;
      this.return_request_subtype = this.itemData.return_request_sub_type ? this.itemData.return_request_sub_type : null;
      this.return_reason = this.itemData.return_reason ? this.itemData.return_reason : null;
      this.retrun_sub_reason = this.itemData.return_sub_reason ? this.itemData.return_sub_reason : null;
      this.issue_reported = this.itemData.issue_reported ? this.itemData.issue_reported : null
      this.type_of_damage = this.itemData.type_of_incident_or_damage ? this.itemData.type_of_incident_or_damage : null
      this.responsible_for_damage = this.itemData.vendor_responsible ? this.itemData.vendor_responsible : null
      this.tag_id = this.itemData.tag_id ? this.itemData.tag_id : null
      this.client_crm_ticket_no = this.itemData.client_crm_ticket_no ? this.itemData.client_crm_ticket_no : null
      this.tag_id_date = this.itemData.tag_date ? this.itemData.tag_date : null
      this.manufacture_date = this.itemData.manufacturing_date ? this.itemData.manufacturing_date : null
      this.batch = this.itemData.batch ? this.itemData.batch : null
      this.vendor_value = this.itemData.vendor ? this.itemData.vendor : null
    }
  },
  methods: {
    updateIds(item) {
      const count = parseInt(item.count);
      if (!isNaN(count) && count > 0) {
        item.tag_ids = Array.from({ length: count }, (_, i) => item.tag_ids?.[i] || '');
        item.box_ids = Array.from({ length: count }, (_, i) => item.box_ids?.[i] || '');
      }
    },
    printWidth() {
      this.$nextTick(() => {
        const combobox = this.$refs.comboboxRef?.$el;
        if (combobox) {
          const inputControl = combobox.querySelector(".v-input__control");
          if (inputControl) {
            this.dynamic_width = inputControl.offsetWidth + "px"
          }
        }
      });
    },
    getItemProps(item) {
        return { disabled: item.disabled };
      },
    closeImageDialog() {        
      const newImagesCount = this.requestImages.length - this.initialrequestImagesLength;
      if (newImagesCount > 0) {
        this.requestImages.splice(this.initialrequestImagesLength, newImagesCount);
        this.requestImageNames.splice(this.initialrequestImagesLength, newImagesCount);
        this.requestImagesFileFormat.splice(this.initialrequestImagesLength, newImagesCount);
      }
      this.addImagesPopup = false;
    },
    closeVideoDialog() {        
      const newVideosCount = this.requestVideos.length - this.initialrequestVideosLength;
      if (newVideosCount > 0) {
        this.requestVideos.splice(this.initialrequestVideosLength, newVideosCount);
        this.requestVideosNames.splice(this.initialrequestVideosLength, newVideosCount);
        this.requestVideosFileFormat.splice(this.initialrequestVideosLength, newVideosCount);
        // setTimeout(() => {
        //   this.validateVideoDuration(this.requestVideos);
        // }, 100);
      }
      this.addVideosPopup = false;
    },
    handleFileChange(newFiles) {
      if (newFiles.length > 8 - (this.itemData && this.itemData.return_images ? this.itemData.return_images.length : 0)) {
        this.imageErrorMessage = `You can upload up to ${this.itemData && this.itemData.return_images ? 8 - this.itemData.return_images.length : '8'} images at a time.`;
      }else {
        this.imageErrorMessage = "";
        this.file = newFiles;
      }
    },
    openImagePopup(){
      this.initialrequestImagesLength = this.requestImages.length;
      this.addImagesPopup = true; 
      const _ = require('lodash');
      this.temp_requestImages = _.cloneDeep(this.requestImages);
      this.temp_requestImagesFileFormat = _.cloneDeep(this.requestImagesFileFormat);
      this.temp_requestImageNames = _.cloneDeep(this.requestImageNames);
    },
    openImagePopupSingle(image) {
      this.selectedImage = image;
      this.imagePopup = true;
    },
    openVideoPopupSingle(video) {
      this.selectedVideo = video;
      this.videoPopup = true;
    },
    openVideosPopup(){
      this.initialrequestVideosLength = this.requestVideos.length;
      this.addVideosPopup = true; 
      this.videoLoading = false; 
      const _ = require('lodash');
      this.temp_requestVideos = _.cloneDeep(this.requestImages);
      this.temp_requestVideosFileFormat = _.cloneDeep(this.requestVideosFileFormat);
      this.temp_requestVideosNames = _.cloneDeep(this.requestVideosNames);
    },
    handleImageUpload1(event) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (this.requestImageNames.includes(file.name)) {
          this.showAlert("error", "This file is already uploaded!");
          return;
        }
        this.requestImageNames.push(file.name);
        const reader = new FileReader();
        reader.onload = (e) => {
          const binaryData = e.target.result;
          this.requestImagesFileFormat.push(file);
          this.confirmUploadFile(file, 'image');
        };
        reader.readAsDataURL(file);
      }
      event.target.value = '';
      this.handleFileChange(this.requestImages);
    },
    confirmUploadFile(file, type) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("attachment_file_name", '');
      const apiUrl = "/api/v1/warehouse/remarketing_buyers/upload_remarketing_buyer_documents";
      this.$httpSecured
      .post(apiUrl, formData)
      .then(response => {
        if (type === 'image') {
          this.requestImages.push(response.data.attachment_file);
        } else if (type === 'video') {
          this.requestVideos.push(response.data.attachment_file);
        }
      })
      .catch(error => {
        this.number = 0;
        this.showAlert("error", error.response.data.master_file);
      });
    },
    handleVideoUpload1(event) {
      const files = Array.from(event.target.files);
      const validFiles = [];
      const invalidFiles = [];
      this.videoLoading = true; // Show loader
      this.videoErrorMessage = "";
      let filesProcessed = 0;
      const startTime = Date.now();
      files.forEach((file) => {
        const videoElement = document.createElement("video");
        const objectURL = URL.createObjectURL(file);
        videoElement.preload = "metadata";
        videoElement.src = objectURL;
        videoElement.onloadedmetadata = () => {
          URL.revokeObjectURL(objectURL); // Free memory
          filesProcessed++;
          if (videoElement.duration > 20) {
            invalidFiles.push(file.name);
          } else {
            validFiles.push(file);
            this.requestVideosNames.push(file.name);
            this.requestVideosFileFormat.push(file);
            this.confirmUploadFile(file, "video");
          }
          // Hide loader when all files are processed
          if (filesProcessed === files.length) {
            const elapsedTime = Date.now() - startTime;
            const remainingTime = Math.max(5000 - elapsedTime, 0);

            setTimeout(() => {
              this.videoLoading = false;
            }, remainingTime);

            if (invalidFiles.length > 0) {
              this.videoLoading = false;
              this.videoErrorMessage = `The following videos exceed 20 sec: ${invalidFiles.join(", ")}`;
              setTimeout(() => {
                this.videoErrorMessage = "";
              }, 3000);
            }
          }
        };
        videoElement.onerror = () => {
          URL.revokeObjectURL(objectURL);
          filesProcessed++;
          if (filesProcessed === files.length) {
            const elapsedTime = Date.now() - startTime;
            const remainingTime = Math.max(5000 - elapsedTime, 0);

            setTimeout(() => {
              this.videoLoading = false;
            }, remainingTime);
          }
          this.videoErrorMessage = "Error processing video file.";
          setTimeout(() => {
            this.videoErrorMessage = "";
          }, 2000);
        };
      });
    },
    submitData() {
      const dataToSubmit = {
        images: this.requestImages,
        videos: this.requestVideos,
      };
      this.submittedData.push(dataToSubmit);
      this.addImagesPopup = false;
      this.addVideosPopup = false;
    },
    removeImage(index) {
      const removedImage = this.requestImages[index]; 
      this.requestImagesFileFormat = this.requestImagesFileFormat.filter(item => {
        return item.name != this.requestImageNames[index]
      });
      this.requestImagesUrl.splice(index, 1);
      this.requestImages.splice(index, 1);
      this.requestImageNames.splice(index, 1);
      this.selectedImages.splice(index, 1);
      this.removedImages.push(removedImage);
      this.$refs.fileInput.value = "";
      this.handleFileChange(this.requestImages);
    },
    removeVideo(index) {
      const removedVideo = this.requestVideos[index]; 
      this.requestVideosFileFormat = this.requestVideosFileFormat.filter(item => {
        return item.name != this.requestVideosNames[index]
      });
      this.requestVideosUrl.splice(index, 1);
      this.requestVideos.splice(index, 1);
      this.requestVideosNames.splice(index, 1);
      // setTimeout(() => {
      //   this.validateVideoDuration(this.requestVideos);
      // }, 100);
      this.videoErrorMessage = '';
      this.videoLoading = false;
      this.removedVideos.push(removedVideo);
      this.$refs.fileInput2.value = "";
      // this.selectedVideo.splice(index, 1);

    },
    // validateVideoDuration(newFiles) {      
    //   if (newFiles.length > 2) {
    //     this.videoErrorMessage = "You can upload up to 2 videos at a time.";
    //     return;
    //   }
    //   this.videoErrorMessage = "";
    //   this.videoLoading = true; 
    //   const validFiles = [];
    //   let errorMessage = "";
    //   let filesProcessed = 0;
    //   newFiles.forEach((file) => {
    //     const videoElement = document.createElement("video");
    //     const objectURL = URL.createObjectURL(file);        
    //     videoElement.preload = "auto"; // Preload full video
    //     videoElement.src = objectURL;        
    //     videoElement.onloadedmetadata = () => {
    //       videoElement.currentTime = videoElement.duration; 
    //       videoElement.onseeked = () => {
    //         const duration = videoElement.duration;
    //         URL.revokeObjectURL(objectURL);
    //         filesProcessed++;
    //         if (duration > 20) {
    //           errorMessage = `Video "${file.name}" exceeds the 20-second limit.`;
    //           this.videoErrorMessage = errorMessage;
    //         } else {
    //           validFiles.push(file);
    //         }
    //       // Ensure all files are processed
    //       if (filesProcessed === newFiles.length) {
    //           this.videoLoading = false; 
    //           if (!errorMessage) {
    //             this.file_video = validFiles;
    //           }
    //         }
    //       };
    //     };
    //     videoElement.onerror = () => {
    //       URL.revokeObjectURL(objectURL);
    //       filesProcessed++;
    //       if (filesProcessed === newFiles.length) {
    //         this.videoLoading = false;
    //         this.videoErrorMessage = "Error processing video files.";
    //       }
    //     };
    //   });
    // },
    loadData() {
      this.loading = true;
      this.selected = []
      this.table_data = []
      this.page = 1
      this.totalPages = 1
      this.pageSize = 100
    },
    Fetchallapis() {
      this.channels();
      this.changeUpdatedBy();
      // this.issueReported();
      this.typeOfDamage();
      this.responsibleForDamage();
    },

    // channel types
    channels() {
      this.$httpSecured
        .get(`/api/v1/warehouse/return_initiation/master_values/channel_types`)
        .then(response => {
          if (response.data) {
            this.channel_items = response.data.lookup_values;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },

    // Return Creation Document keys
    changeUpdatedBy() {
      this.$httpSecured
        .get(`/api/v1/warehouse/return_initiation/master_values/return_creation_document_keys`)
        .then(response => {
          if (response.data) {
            this.updated_by_items = response.data.lookup_values.map(item => {
              if (this.currentUser.roles[0] === 'area_service_manager') {
                return {
              ...item,
                  disabled: item.original_code !== 'Serial Number', 
                };
              } else {
                return { ...item, disabled: false };
              }
            });
            this.updated_by_items = this.updated_by_items.filter(item => 
              item.original_code === 'Serial Number' || 
              item.original_code === 'Count' || 
              item.original_code === 'Article ID & Count'
            );
          } else {
            this.showAlert("error", "No Data Found");
          }
          this.loading = false;
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network:" + error);
          this.loading = false;
        });
    },

    // Return Sub Type
    fetchAllData(id, itemid) {
      const params = {
        lookup_value_id: id
      };
      let apiURL = null;
      if (this.$store.state.actionRequest === 'requested') {
        apiURL = '/api/v1/warehouse/return_initiation/master_values/return_sub_types';
        // apiURL = `/api/v1/warehouse/return_initiation/master_values/${itemid}/bb_return_sub_types`;
      } else {
        apiURL = '/api/v1/warehouse/return_initiation/master_values/return_sub_types';
      }
      if (apiURL === null) {
        this.loading = false;
        return;
      }
      this.$httpSecured
      .get(apiURL, { params: params })
      .then((response) => {
        this.return_request_subtype_items =
          this.$store.state.actionRequest === 'requested' ? response.data.lookup_values : response.data.lookup_values;
      })
      .catch((error) => {
        this.showAlert("error", "Something went wrong from Network: " + error);
        this.loading = false;
      });
    },
    clearIfNotSelected(model, items, comboboxRef) {
      if (!this[model] || !Array.isArray(this[items])) {
        return;
      }

      const selectedItem = this[items].find(
        item => item.id === this[model].id
      );

      if (!selectedItem) {
        this[model] = null;
        if (this.$refs[comboboxRef]) {
          this.$refs[comboboxRef].internalSearch = '';
        }
      }
    },
    //Return Reasons
    returnreason() {
      // this.return_reason = null;
      // this.retrun_sub_reason = null;
      const params = {
        lookup_value_id: this.return_request_subtype.id
      }
      if(this.$store.state.actionRequest === 'requested'){
        var apiURL = '/api/v1/warehouse/return_initiation/master_values/return_reasons'
        // var apiURL = `/api/v1/warehouse/return_initiation/master_values/${this.itemData.id}/bb_return_reasons?code=${this.return_request_subtype.code}`
      }else {
        var apiURL = '/api/v1/warehouse/return_initiation/master_values/return_reasons'
      }
      this.$httpSecured
      .get(apiURL, { params: params })
      .then(response => {
          if (response.data) {
            this.return_reason_items = this.$store.state.actionRequest === 'requested' ? response.data.lookup_values : response.data.lookup_values;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.loading = false;
          this.showAlert("error", error.response.data.error);
        });
    },

    // Return Sub Reasons
    returnSubReason() {
      this.retrun_sub_reason = null;
      const params = {
        lookup_value_id: this.return_reason.id
      }
      if(this.$store.state.actionRequest === 'requested'){
        var apiURL = '/api/v1/warehouse/return_initiation/master_values/return_sub_reasons'
        // var apiURL = `/api/v1/warehouse/return_initiation/master_values/${this.itemData.id}/bb_return_sub_reasons?code=${this.return_reason.code}`
      }else {
        var apiURL = '/api/v1/warehouse/return_initiation/master_values/return_sub_reasons'
      }
      this.$httpSecured
      .get(apiURL, { params: params })
      .then(response => {
          if (response.data) {
            this.retrun_sub_reason_itmes = this.$store.state.actionRequest === 'requested' ? response.data.lookup_values : response.data.lookup_values;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.loading = false;
          this.showAlert("error", error.response.data.error);
        });
    },

    // Return incident issue reported
    issueReported() {
      this.issue_reported = null;
      this.type_of_damage = null;
      const selectedSerialNumber = this.itemDetailsFields.find(item => {
        return item.serial_number2 !== '';
      });
      const selectedArticleId = this.itemDetailsFields.find(item => {
        return item.article_id !== '';
      });
      let parameter = '';
      if (selectedSerialNumber) {
        parameter = `serial_number=${selectedSerialNumber.serial_number2}`;
      } 
      if (selectedArticleId) {
        parameter = `sku_code=${selectedArticleId.article_id}`;
      }
      this.$httpSecured
        .get(`/api/v1/warehouse/return_initiation/master_values/sympton_list?${parameter}`)
        .then(response => {
          if (response.data) {
            const uniqueMappingValues = [];
            response.data.data.forEach(item => {
              const mappingValue = item.mapping_value;
              const isDuplicate = uniqueMappingValues.includes(mappingValue);
              if (!isDuplicate) {
                uniqueMappingValues.push(mappingValue);
              }
            });
            this.issue_reported_items = uniqueMappingValues;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },

    // Return incident damage types
    typeOfDamage() {
      this.type_of_damage = '';
      this.$httpSecured
        .get(`/api/v1/warehouse/return_initiation/master_values/return_incident_damage_types`)
        .then(response => {
          if (response.data) {
            this.type_of_damage_items = response.data.lookup_values;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.loading = false;
          this.showAlert("error", error.response.data.error);
        });
    },

    // Return vendor responsible
    responsibleForDamage() {
      this.responsible_for_damage = '';
      this.$httpSecured
        .get(`/api/v1/warehouse/return_initiation/master_values/return_vendor_responsible`)
        .then(response => {
          if (response.data) {
            this.responsible_for_damage_items = response.data.lookup_values;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.loading = false;
          this.showAlert("error", error.response.data.error);
        });
    },

    handleAddMoreItems() {
      const lastItem = this.itemDetailsFields[this.itemDetailsFields.length - 1];
      // if (lastItem.updated_by !== 'Serial Number') {
      //   this.disabledAddMore = true;
      //   return;
      // }
      const newItem = {
        field_id: lastItem.field_id || '',
        field_value: lastItem.field_value || '',
        document_number: '',
        article_id: '',
        serial_number2: '',
        invoice_number: '',
        count: '',
        box_id: '',
        tag_id: '',
        client_crm_ticket_no: '',
        weatherData: null,
        articleId: null,
        lease_contract_reference_number: '',
        vendor_reference_code: '',
        tag_ids: '',
        box_ids: '',
      };

      this.itemDetailsFields.push(newItem);
    },
    
    addInvoiceItems() {
      if (this.edit_invoice_selected.length === 0) {
        this.$toast.error("Please Select Data");
      } else {
        this.invoiceItemPopup = false;
        this.searchInvoicePopup = false;
      }
    },

    addLeaseItems() {
      if (this.edit_lease_selected.length === 0) {
        this.$toast.error("Please Select Data");
      } else {
        this.leaseItemPopup = false;
        this.searchLeaseContractPopup = false;
      }
    },

    closeInvoiceItemPopup() {
      this.edit_invoice_selected = [];
      this.edit_lease_selected = [];
      this.invoiceItemPopup = false;
      this.leaseItemPopup = false;
    },

    closeSearchInvoicePopup() {
      this.searchInvoicePopup = false;
      this.searchLeaseContractPopup = false;
      this.itemDetailsFields[this.itemDetailsFields.length-1].updated_by = '';
    },


    openInvoiceItemPopup() {
      this.invoice_id = this.search_invoice;
      this.selected = [];
      this.invoiceItemPopup = true;
      this.edit_invoice_headers = [
        { title: "Article ID", key: "sku_code" },
        { title: "Article Description", key: "sku_description", sortable: false },
        { title: "Serial Number", key: "serial_number" },
        { title: "Qty", key: "quantity" },
        // { title: "", key: "delete" },
      ];

      const params = {
        reference_document_number: this.invoice_id,
        customer_name: this.customer_name,
      }

      this.$httpSecured
        .get(`/api/v1/warehouse/return_initiation/return_inventory_informations/search_return_items_new?`, { params: params })
        .then(response => {
          if (response.data) {
            this.edit_invoice_table_data = response.data.return_inventory_informations;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.loading = false;
          this.showAlert("error", error.response.data.error);
        });
    },

    openLeaseReferenceItemPopup(){
      this.lease_id = this.lease_contract_reference_number;
      this.selected = [];
      this.leaseItemPopup = true;
      this.edit_invoice_headers = [
        { title: "Article ID", key: "sku_code" },
        { title: "Article Description", key: "sku_description", sortable: false },
        { title: "Serial Number", key: "serial_number" },
        { title: "Qty", key: "quantity" },
        // { title: "", key: "delete" },
      ];

      const params = {
        reference_document_number: this.lease_id,
        customer_name: this.customer_name,
      }

      this.$httpSecured
        .get(`/api/v1/warehouse/return_initiation/return_inventory_informations/search_return_items_new?`, { params: params })
        .then(response => {
          if (response.data) {
            this.edit_invoice_table_data = response.data.return_inventory_informations;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.loading = false;
          this.showAlert("error", error.response.data.error);
        });
    },

    removeItem(dataItem, index) {
      this.edit_invoice_table_data.splice(index, dataItem.id);
    },

    selectInvoiceValue(field) {
      if (field === 'customer_name' && (this.customer_name.trim().length === 0 || !this.customer_name_list.some(item => item == this.customer_name)) ) {
        return;
      }
      console.log(field+"  test server")
      this.populateInvoiceData();
    },

    basedOnSelectValue(value) {
      if (value.updated_by) {
        this.updated_by_items.forEach(item => {
          if (item.updated_by === value.updated_by) {
            value.updated_by.original_code = item.original_code
            value.updated_by.id = item.id
          }
        })
        this.field_id = value.updated_by.id
        this.field_value = value.updated_by.original_code
        value.field_id = value.updated_by.id
        value.field_value = value.updated_by.original_code
        localStorage.setItem('field_value', this.field_value);
        if (value.updated_by.original_code === "Invoice") {
          this.searchInvoicePopup = true;
          this.search_invoice = null
        } else {
          this.searchInvoicePopup = false;
        }
        if(value.updated_by.original_code === "Lease Contract Reference Number"){
          this.searchLeaseContractPopup = true;
          this.lease_contract_reference_number = null
        }else {
          this.searchLeaseContractPopup = false;
        }
      }

      if (value.article_id) {
        this.article_id_list.forEach(item => {
          if (item.article_id === value.article_id) {
            value.article_id = item.article_id
          }
        })
        this.article_value = value.article_id
        this.searchItems("article_id", value.article_id);
        this.selectInvoiceValue();
      }

      if (value.vendor_reference_code) {
        this.vendor_reference_code_list.forEach(item => {
          if (item.vendor_reference_code === value.vendor_reference_code) {
            value.vendor_reference_code = item.vendor_reference_code
          }
        })
        this.vendor_reference_code_value = value.vendor_reference_code
        this.searchItems("vendor_reference_code", value.vendor_reference_code);
        this.selectInvoiceValue();
      }

      if (value.serial_number2) {
        this.serial_number_list.forEach(item => {
          if (item === value.serial_number2) {
            value.serial_number2 = item
          }
        })
        this.serial_number_value = value.serial_number2
        this.searchItems("serial_number", value.serial_number2);
        this.selectInvoiceValue();
      }
      if (value.field_value === "Serial Number") {
        value.article_id = null;
        value.serial_number2 = null;
        value.tag_ids = [];
        value.box_ids = [];
        value.count = null;
      } else if (value.field_value === "Article ID & Count") {
        value.article_id = null;
        value.tag_ids = [];
        value.box_ids = [];
        value.count = null;
      } else {
        value.tag_ids = [];
        value.box_ids = [];
        value.count = null;
      }
      
    },

    getMatchingItemDetail(item) {
      return this.itemDetailsFields.find(itemDetail => {
        return itemDetail.field_id && itemDetail.field_value === 'Invoice' || (itemDetail.field_value === 'Invoice' && this.itemData.reference_document === 'Invoice');
      });
    },
    // Search Items
    searchItems(field, value) {
       if(this.componentText === 'D2C Sales Return'){
         return;
       }

      if (field === 'customer_name' && value.trim().length === 0) {
        return;
      }
      if (field !== 'search_invoice') {
        this.searched_invoice = '';
      }
      if (field !== 'customer_name'){
        this.searched_customer_name = '';
      }
      if (field === 'customer_name') {
        this.searched_customer_name = value;
      } else if (field === 'serial_number') {
        this.serial_no1 = value;
      } else if (field === 'article_id') {
        this.article_no1 = value;
      } else if (field === 'search_invoice') {
        this.searched_invoice = value;
      } else if (field === 'lease_contract_reference_number') {
        this.lease_contract_reference_number = value;
      } else if (field === 'vendor_reference_code') {
        this.vendor_reference_code1 = value;
      }

      if (value.trim() !== '') {
        this.fetchSearchData();
      }
    },

    fetchSearchData() {
      this.loading = true;
      let url = null;
      if(this.currentUser.roles[0] === 'area_service_manager'){
        url = `api/v1/warehouse/return_initiation/return_inventory_informations/search_return_items_new?customer_name=&only_dealer=true&user_id=${this.currentUser.id}`;
      }else{
        url = '/api/v1/warehouse/return_initiation/return_inventory_informations/search_return_items_new?';
      }
      const params = {
        customer_name: this.itemData == '' ? this.searched_customer_name : this.itemData.customer_name,
        // reference_document_number: this.searched_invoice,
        // serial_number: this.serial_no1 || "",
        // vendor_reference_code: this.vendor_reference_code1 || "",
        // sku_code: this.article_no1 || "",
      }
      if (url === null) {
        this.loading = false; 
        return;
      }
      this.$httpSecured
        .get(url, { params: params })
        .then(response => {
          if (response.data) {
            this.customer_name_list = [];
            this.customer_number_list = [];
            this.item_location_items = [];
            this.serial_number_list = [];
            this.article_id_list = [];
            this.vendor_reference_code_list = [];
            const executives = response.data.user_partner_executives;
            if (this.currentUser.roles[0] === 'warehouse_manager') {
              this.item_location_items = executives
                .map(exec => exec.address_with_warehouse_code)
                .flat();
            }
            this.search_invoice_list = [];
            this.search_return_items = response.data.user_partner_executives;
            for (var i = 0; i < this.search_return_items.length; i++) {
              if (this.search_return_items[i].customer_name === this.customer_name || this.search_return_items[i].reference_document_number === this.search_invoice || this.search_return_items[i].serial_number === this.serial_number2 || this.search_return_items[i].sku_code === this.article_id) {
                this.return_inventory_information_id = this.search_return_items[i].id
              }
              // if(this.componentText !== 'Warranty Claim'){
              //   this.customer_name_list.push(this.search_return_items[i].client_name);
              // }
              if (this.componentText !== 'Warranty Claim' || this.currentUser.roles[0] == 'area_service_manager' || this.currentUser.roles[0] == 'warehouse_manager'){
                this.customer_name_list.push(`${this.search_return_items[i].client_name} - (${this.search_return_items[i].client_id})`);
              }
              // this.customer_number_list.push(this.search_return_items[i].customer_phone);
              // this.item_location_items.push(this.search_return_items[i].item_location);
              // this.serial_number_list.push(this.search_return_items[i].serial_number);
              // this.article_id_list.push(this.search_return_items[i].sku_code);
              // this.vendor_reference_code_list.push(this.search_return_items[i].vendor_reference_code);
              // this.search_invoice_list.push(this.search_return_items[i].reference_document_number);
            }
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.loading = false;
          // this.showAlert("error", error.response.error);
        });
    },

    populateInvoiceData() {
      if (!this.customer_name) {
        this.showAlert("error", "Customer name is missing.");
        return;
      }
      this.loading = true;
      const params = {
        customer_name: this.customer_name.split(' - ')[0],
        // customer_phone: this.contact_number
        // reference_document_number: this.search_invoice,
        // vendor_reference_code: this.vendor_reference_code1 || "",
        // serial_number: this.serial_no1 || "",
        // sku_code: this.article_no1 || "",
      }
      this.$httpSecured
        .get(`/api/v1/warehouse/return_initiation/return_inventory_informations/search_return_items_new?`, { params: params })
        .then(response => {
          if (response.data) {
            this.serial_number_list = [];
            this.article_id_list = [];
            this.item_location_items = [];
            this.vendor_reference_code_list = [];
            this.search_invoice_list = [];
            const executives = response.data.user_partner_executives;
            if(this.currentUser.roles[0] === 'warehouse_manager'){
              this.item_location_items = executives
            .map(exec => exec.address_with_warehouse_code)
            .flat();
            }
            if(this.currentUser.roles[0] === 'area_service_manager'){
              this.search_return_items = response.data.user_partner_executives;
            }else{
              this.search_return_items = response.data.return_inventory_informations;
            }
            for (var i = 0; i < this.search_return_items.length; i++) {
              if (this.search_return_items[i].customer_name === this.customer_name || this.search_return_items[i].reference_document_number === this.search_invoice || this.search_return_items[i].serial_number === this.serial_number2 || this.search_return_items[i].sku_code === this.article_id) {
                this.return_inventory_information_id = this.search_return_items[i].id
              }
              // this.customer_name_list.push(this.search_return_items[i].customer_name);
              // this.customer_number_list.push(this.search_return_items[i].customer_phone);
              // this.item_location_items.push(this.search_return_items[i].item_location);
              if(this.currentUser.roles[0] === 'area_service_manager'){
                this.item_location_items = this.search_return_items[0].address;
              }
              // if (this.componentText !== 'Warranty Claim' || this.currentUser.roles[0] === 'area_service_manager' || this.currentUser.roles[0] === 'warehouse_manager'){
              //   this.customer_name_list.push(`${this.search_return_items[i].client_name} - (${this.search_return_items[i].client_id})`);
              // }
              this.serial_number_list.push(this.search_return_items[i].serial_number);
              this.article_id_list.push(this.search_return_items[i].sku_code);
              this.vendor_reference_code_list.push(this.search_return_items[i].vendor_reference_code);
              this.search_invoice_list.push(this.search_return_items[i].reference_document_number);

            }
            if(this.currentUser.roles[0] !== 'area_service_manager'){
              this.customer_name = '';
              this.contact_number = '';
              this.item_location = '';
            }
            this.setEditLotParams();
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.loading = false;
          this.showAlert("error", error.response.data.error);
        });
    },

    setEditLotParams() {
      if (this.search_return_items === '') {
        this.customer_name = '';
        this.contact_number = '';
        this.item_location = '';
      } else {
        if(this.currentUser.roles[0] == 'area_service_manager'){
          // this.customer_name = this.search_return_items[0].client_name
          // this.customer_name = this.search_return_items[i].client_name - `(${this.search_return_items[0].client_id})`
          this.clientID = this.search_return_items[0].client_id
          this.contact_number = this.search_return_items[0].contact_no
          this.branch = this.search_return_items[0].branch
          if(this.search_return_items[0].address.length === 1){
            this.item_location = this.search_return_items[0].address
          }
        }else{
          this.customer_name = this.search_return_items[0].customer_name
          this.contact_number = this.search_return_items[0].customer_phone
          this.item_location = this.search_return_items[0].item_location
        }
        this.return_inventory_information_id = this.search_return_items[0].id
        this.searched_invoice = this.search_invoice
      }
    },

    // Sent Otp
    sentOTP() {
      this.loading = true;
      const params = {
        contact_number: this.contact_number
      }
      this.$httpSecured
        .get(`/api/v1/warehouse/return_initiation/return_creations/send_otp?`, { params: params })
        .then(response => {
          if (response.data.type === "success") {
            this.enterOtpPopup = true;
            this.startTimer();
            this.loading = false;
            this.getOTPDetails();
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.loading = false;
          this.showAlert("error", error.response.data.error);
        });
    },

    // Get OTP Details
    getOTPDetails() {
      const params = {
        contact_number: this.contact_number
      }
      this.$httpSecured
        .get(`/api/v1/warehouse/return_initiation/return_creations/get_otp_details?`, { params: params })
        .then(response => {
          if (response.data) {
            this.otp_verification_details = response.data.otp_verifications;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.loading = false;
          this.showAlert("error", error.response.data.error);
        });
    },

    // Verify otp(put)
    verifyOTP() {
      this.$httpSecured.put(`/api/v1/warehouse/return_initiation/return_creations/verify_otp`, {
        "otp": this.enter_otp,
        "contact_number": this.contact_number
      })
        .then(response => {
          if (response.data) {
            this.enter_otp = '';
            this.enterOtpPopup = false;
            this.submitForm();
          } else {
            this.showAlert(response.data.type);
            this.showError(response.data.message);
          }
        }).catch(error => {
          this.$toast.error(error.response.data.message);
          this.isLoading = false;
        });
    },

    closeEnterOtpPopup() {
      this.enter_otp = '';
      this.enterOtpPopup = false;
    },

    // Update Return Item Data(Update)
    updateReturnItemTicket(){
      this.item_id = this.itemData.id
      this.viewErrorLogPopup = false;
      let ref_selected_key = "";
      let ref_selected_value = "";
      let ref_id = "";
      let ref_ids = "";
      if(this.field_value === "Invoice"){
        ref_selected_key = "invoice_number"
        ref_selected_value = this.search_invoice

        const invoice_id = this.edit_invoice_selected.map(item => item.id).join(',');
        ref_id = "ids"
        ref_ids = invoice_id
      }else if(this.field_value === "Article ID & Count"){
        ref_selected_key = this.article_value
        const selectedItem = this.itemDetailsFields.find(item => {
          return item.count !== '';
        });
        
        if (selectedItem) {
          ref_selected_value = parseInt(selectedItem.count); // Parse count as integer
        }

      }else if(this.field_value === "Vendor Reference Code"){
        ref_selected_key = "vendor_reference_code"
        ref_selected_value = this.vendor_reference_code_value
      }else if(this.field_value === "Serial Number"){
        ref_selected_key = "serial_number"
        ref_selected_value = this.serial_number2
      }else if (this.field_value === "Count"){
        ref_selected_key = "count"
        const selectedItem = this.itemDetailsFields.find(item => {
          return item.count !== '';
        });
        
        if (selectedItem) {
          ref_selected_value = selectedItem.count;
        }
      }
      const requestData = {
        return_item_ticket: {
          reference_document: this.field_value,
          reference_document_details: {
            [ref_selected_key]: ref_selected_value,
          },
          channel_id: this.channel ? this.channel.id : '',
          channel: this.channel ? this.channel.original_code : '',
          return_request_sub_type_id: this.return_request_subtype ? this.return_request_subtype.id : '',
          return_request_sub_type: this.return_request_subtype ? this.return_request_subtype.original_code : '' ,
          return_reason_id: this.return_reason ? this.return_reason.id : '',
          return_reason: this.return_reason ? this.return_reason.original_code : '',
          return_sub_reason_id:this.retrun_sub_reason ? this.retrun_sub_reason.id : '',
          return_sub_reason: this.retrun_sub_reason ? this.retrun_sub_reason.original_code : '',
          issue_reported_id: this.issue_reported ? this.issue_reported.id : '',
          issue_reported: this.issue_reported ? this.issue_reported : null,
          type_of_incident_or_damage_id: this.type_of_damage ? this.type_of_damage.id : '',
          type_of_incident_or_damage: this.type_of_damage ? this.type_of_damage.original_code : '',
          vendor_responsible_id: this.responsible_for_damage ? this.responsible_for_damage.id : '',
          vendor_responsible: this.responsible_for_damage ? this.responsible_for_damage.original_code : '',
        },
      }
      if (this.field_value === "Invoice") {
        requestData.return_item_ticket.reference_document_details[ref_id] = ref_ids;
      }
      this.$httpSecured.put(`/api/v1/warehouse/return_initiation/return_creations/${this.item_id}/update_ticket`, requestData)
      .then(response => {
        if (response.data) {
          this.returncreationsuccessmessage = response.data.message;
          this.returncreateionsuccesspopup = true
        } else {
          this.showAlert(response.data.type);
        }
      }).catch(error => {
        this.showAlert("error", error.response.data.error);
        this.loading = false;
      });
    },

    updateRequestItem() {
      this.item_id = this.itemData.id
      if (this.submittedData[0]) {
        this.submittedData[0].images.push(...this.itemData.return_images);
        this.submittedData[0].videos.push(...this.itemData.return_videos);
      }
      const returnImages = this.submittedData[0] ? this.submittedData[0].images : this.itemData.return_images.length ? this.itemData.return_images : [];
      const returnVideos = this.submittedData[0] ? this.submittedData[0].videos : this.itemData.return_videos.length ? this.itemData.return_videos : [];
      if(this.currentUser.roles[0] === 'area_service_manager'){
        var returnReqeustSubTypeId = this.return_request_subtype ? this.return_request_subtype.id : '';
        var returnReqeustSubTypeValue = this.return_request_subtype ? this.return_request_subtype.original_code : '';
        var returnReasonId = this.return_reason ? this.return_reason.id : '';
        var returnReasonValue = this.return_reason ? this.return_reason.value : '';
        var returnSubReasonId = this.retrun_sub_reason ? this.retrun_sub_reason.code : '';
        var returnSubReasonValue = this.retrun_sub_reason ? this.retrun_sub_reason.value : '';
      }else{
        var returnReqeustSubTypeId = this.return_request_subtype ? this.return_request_subtype.id : '';
        var returnReqeustSubTypeValue = this.return_request_subtype ? this.return_request_subtype.original_code : '';
        var returnReasonId = this.return_reason ? this.return_reason.id : '';
        var returnReasonValue = this.return_reason ? this.return_reason.original_code : '';
        var returnSubReasonId = this.retrun_sub_reason ? this.retrun_sub_reason.id : '';
        var returnSubReasonValue = this.retrun_sub_reason ? this.retrun_sub_reason.original_code : '';
      }
      const requestData = {
        return_item: {
          channel_id: this.channel ? this.channel.id : '',
          channel: this.channel ? this.channel.original_code : '',
          // return_request_sub_type_id: returnReqeustSubTypeId,
          // return_request_sub_type: returnReqeustSubTypeValue,
          // return_reason_id: returnReasonId,
          // return_reason: returnReasonValue,
          // return_sub_reason_id: returnSubReasonId,
          // return_sub_reason: returnSubReasonValue,
          return_request_sub_type_id: this.return_request_subtype ? this.return_request_subtype.id : '',
          return_request_sub_type: this.return_request_subtype ? this.return_request_subtype.original_code : '',
          return_reason_id: this.return_reason ? this.return_reason.id : '',
          return_reason: this.return_reason ? this.return_reason.original_code : '',
          return_sub_reason_id:this.retrun_sub_reason ? this.retrun_sub_reason.id : '',
          return_sub_reason: this.retrun_sub_reason ? this.retrun_sub_reason.original_code : '',
          tag_id: this.tag_id,
          client_crm_ticket_no: this.client_crm_ticket_no,
          tag_dates: this.formatDate(this.tag_id_date).split('-').reverse().join('-'),
          manufacturing_date: this.formatDate(this.manufacture_date).split('-').reverse().join('-'),
          batch: this.batch,
          vendor:this.vendor_value,
          issue_reported_id: this.issue_reported ? this.issue_reported.id : '',
          issue_reported: this.issue_reported ? this.issue_reported : '',
          type_of_incident_or_damage_id: this.type_of_damage ? this.type_of_damage.id : '',
          type_of_incident_or_damage: this.type_of_damage ? this.type_of_damage.original_code : '',
          vendor_responsible_id: this.responsible_for_damage ? this.responsible_for_damage.id : '',
          vendor_responsible: this.responsible_for_damage ? this.responsible_for_damage.original_code : '',
          return_images: returnImages,
          return_videos: returnVideos,
        },
      }
      // filtering only updated data, removing the key with undefined value
      const filtered_data = {
        return_item : {}
      }
      for(let key in requestData.return_item)
        if(requestData.return_item[key])
          if((typeof requestData.return_item[key] == 'object' && requestData.return_item[key].length))
            filtered_data.return_item[key] = requestData.return_item[key]
          else if(typeof requestData.return_item[key] != 'object')
            filtered_data.return_item[key] = requestData.return_item[key]
          
      this.$httpSecured.put(`/api/v1/warehouse/return_initiation/return_creations/${this.item_id}/update_request_item`, requestData)
      .then(response => {
        if (response.data) {
          this.returncreationsuccessmessage = response.data.message;
          this.returncreateionsuccesspopup = true
        } else {
          this.showAlert(response.data.type);
        }
      }).catch(error => {
        this.showAlert("error", error.response.data.error);
        this.showAlert("error", error.response.data.message);
        this.loading = false;
      });
    },

    afterClickOkLoadData() {
      this.successpopup = false;
      this.successmessage = ''
      this.selected = [];
    },

    // convertToBase64(file) {
    //   return new Promise((resolve, reject) => {
    //     const reader = new FileReader();
    //     reader.readAsDataURL(file);
    //     reader.onload = () => resolve(reader.result);
    //     reader.onerror = error => reject(error);
    //   });
    // },
    // async handleImageUpload() {
    //   if (this.file) {
    //     try {
    //       const base64String = await this.convertToBase64(this.file);
    //       await this.imageUpload(base64String); // Pass the base64 string to the submitForm function
    //     } catch (error) {
    //       console.error("Error converting the image to base64:", error);
    //     }
    //   }
    // },

    async imageUpload(base64String) {
      const formData = new FormData();
      formData.append('image_url', base64String);
      try {
        const response = await this.$httpSecured.post('/api/v1/store/returns/customer_returns/upload', formData);
        this.path = response.data.path_name;
      } catch (error) {
        console.error("Error uploading the image:", error);
      }
    },
    
    // Return Creation
    async submitForm() {
      this.isLoading = true;
      let ref_selected_key = "";
      let ref_selected_value = "";
      let ref_id = "";
      let ref_ids = "";
      if (this.field_value === "Invoice") {
        ref_selected_key = "invoice_number"
        ref_selected_value = this.search_invoice

        const invoice_id = this.edit_invoice_selected.map(item => item.id).join(',');
        ref_id = "ids"
        ref_ids = invoice_id
      } if (this.field_value === "Lease Contract Reference Number") {
        ref_selected_key = "reference_number"
        ref_selected_value = this.lease_contract_reference_number

        const lease_id = this.edit_lease_selected.map(item => item.id).join(',');
        ref_id = "ids"
        ref_ids = lease_id
      } else if (this.field_value === "Article ID & Count") {
        // const selectedArticleId = this.itemDetailsFields.find(item => {
        //   return item.article_id !== '';
        // });
        // if (selectedArticleId) {
        //   ref_selected_key = selectedArticleId.article_id;
        // }
        // const selectedItem = this.itemDetailsFields.find(item => {
        //   return item.count !== '';
        // });

        // if (selectedItem) {
        //   ref_selected_value = parseInt(selectedItem.count); // Parse count as integer
        // }
        const articleCountMap = {};
        this.itemDetailsFields.forEach(item => {
          if (item.article_id && item.count) {
            articleCountMap[item.article_id] = parseInt(item.count);
          }
        });

        ref_selected_key = null;
        ref_selected_value = articleCountMap;

        // Prepare tag_details_arr as [["tag_id", "box_id"], ...]
        this.tagDetailsArray = [];
        this.itemDetailsFields.forEach(item => {
          if (item.tag_ids && item.box_ids && item.tag_ids.length === item.box_ids.length) {
            for (let i = 0; i < item.tag_ids.length; i++) {
              this.tagDetailsArray.push([item.tag_ids[i], item.box_ids[i]]);
            }
          }
        });
      } else if(this.field_value === "Vendor Reference Code"){
        ref_selected_key = "vendor_reference_code"
        ref_selected_value = this.vendor_reference_code_value
      }else if (this.field_value === "Serial Number") {
        ref_selected_key = "serial_number"
        // const selectedSerialNumber = this.itemDetailsFields.find(item => {
        //   return item.serial_number2 !== '';
        // });
        // if (selectedSerialNumber) {
        //   ref_selected_value = selectedSerialNumber.serial_number2;
        // }
        const serialDataArray = this.itemDetailsFields
          .filter(item => item.serial_number2 !== '')
          .map(item => [
            item.serial_number2 || '',
            item.article_id || '',
            item.tag_ids.length > 0 ? item.tag_ids : '',
            item.box_ids.length > 0 ? item.box_ids : ''
          ]);

        if (serialDataArray.length) {
          ref_selected_value = serialDataArray;
        }
      } else if (this.field_value === "Count") {
        ref_selected_key = "count"
        const selectedItem = this.itemDetailsFields.find(item => {
          return item.count !== '';
        });

        if (selectedItem) {
          ref_selected_value = selectedItem.count;
        }
      }
      const requestData = {
        return_item_ticket: {
          return_type_id: this.returntype,
          return_type: this.returnvalue,
          return_inventory_information_id: '',
          customer_type: this.customer_type,
          customer_name: this.customer_name,
          tag_id: this.tag_id,
          client_crm_ticket_no: this.client_crm_ticket_no,
          tag_dates: this.formatDate(this.tag_id_date).split('-').reverse().join('-'),
          manufacturing_date: this.formatDate(this.manufacture_date).split('-').reverse().join('-'),
          batch: this.batch,
          vendor:this.vendor_value,
          customer_name_with_code: this.currentUser.roles[0] === 'area_service_manager' 
            ? this.customer_name + '-' + (this.clientID) 
            : '',
          contact_number: this.contact_number ? this.contact_number : '',
          alternate_contact_number: this.alternate_contact_number ? this.alternate_contact_number : '',
          // item_location: this.update_item_location ? this.update_item_location : this.item_location.join(','),
          item_location: this.currentUser.roles[0] === 'area_service_manager'
            ? Array.isArray(this.item_location)
              ? this.item_location.filter(location => location.trim() !== '').join(', ') // Filters out empty strings and joins non-empty values
              : this.item_location
            : this.item_location,
          location: this.update_item_location ? [this.update_item_location] : this.item_location,
          branch: this.branch,
          is_different_location: this.isChecked,
          reference_document: this.field_value,
          reference_document_details:
            ref_selected_key && ref_selected_value
              ? { [ref_selected_key]: ref_selected_value }
              : ref_selected_value,
          channel_id: this.channel ? this.channel.id : '',
          channel: this.channel ? this.channel.original_code : '',
          return_request_sub_type_id: this.return_request_subtype ? this.return_request_subtype.id : '',
          return_request_sub_type: this.return_request_subtype ? this.return_request_subtype.original_code : '',
          return_reason_id: this.return_reason ? this.return_reason.id : '',
          return_reason: this.return_reason ? this.return_reason.original_code : '',
          return_sub_reason_id:this.retrun_sub_reason ? this.retrun_sub_reason.id : '',
          return_sub_reason: this.retrun_sub_reason ? this.retrun_sub_reason.original_code : '',
          issue_reported_id: this.issue_reported ? this.issue_reported.id : '',
          issue_reported: this.issue_reported ? this.issue_reported : '',
          type_of_incident_or_damage_id: this.type_of_damage ? this.type_of_damage.id : '',
          type_of_incident_or_damage: this.type_of_damage ? this.type_of_damage.original_code : '',
          vendor_responsible_id: this.responsible_for_damage ? this.responsible_for_damage.id : '',
          vendor_responsible: this.responsible_for_damage ? this.responsible_for_damage.original_code : '',
          return_processing_location:this.edit_invoice_selected.map(item => item.location_code),
          return_images: this.submittedData[0] ? this.submittedData[0].images : [],
          return_videos: this.submittedData[0] ? this.submittedData[0].videos : [],
        },
      };

      if (this.field_value === "Invoice") {
        requestData.return_item_ticket.reference_document_details[ref_id] = ref_ids;
      }
      if (this.field_value === "Article ID & Count") {
        requestData.return_item_ticket.tag_details_arr = this.tagDetailsArray;
      }
      if (this.field_value === "Lease Contract Reference Number") {
        requestData.return_item_ticket.reference_document_details[ref_id] = ref_ids;
      }

      this.$httpSecured
        .post("/api/v1/warehouse/return_initiation/return_creations/create_ticket_from_fta", requestData)
        .then((response) => {
          if (response.data) {
            this.returncreationsuccessmessage = response.data.message;
            this.returncreateionsuccesspopup = true
            this.loadData();
            this.isLoading = false;
          } else {
            this.isLoading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          if(error.response.data.payload){
            this.isLoading = false;
            this.viewErrorLogPopup = this.organization_name === "Blubirch" ? false : true
            this.request_log = error.response.data.payload
            this.response_log = error.response.data.response
          }else{
            this.viewErrorLogPopup = this.organization_name === "Blubirch" ? false : true
            this.request_log = requestData
            this.response_log = error.response.data.error
           this.showAlert("error", error.response.data.error);
           this.isLoading = false;
          }
        });
    },

    redirectToreturncreation() {
      this.returncreateionsuccesspopup = false;
      this.returncreationsuccessmessage = ''
      this.$router.push({ name: "ReturnCreationRia" });
    },

    getRequestParams(page, pageSize) {
      let params = {};

      if (page) {
        params["page"] = page;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      return params;
    },
    normalizeToArray(val) {
      if (Array.isArray(val)) return val;

      if (typeof val === 'string') {
        try {
          const parsed = JSON.parse(val);
          return Array.isArray(parsed) ? parsed : [val];
        } catch (e) {
          return [val];
        }
      }

      return [];
    },
    showAlert(alert_type, alert_message) {
      this.scrollToTop();
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    formatDate(dateStr) {
      if (dateStr) {
        const date = new Date(dateStr);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
      return '';
    },
   cancelExpiryDate(){
       this.tag_id_date = null
       this.menu3 = false
     },
     cancelManufactureDate(){
       this.manufacture_date = null
       this.menu4 = false
     }
  }
}
</script>

<style scoped>
:deep(.combobox-width .v-input__control) {
  width: 100%;
}

.combobox-width.v-combobox--active-menu {
  width: 100% !important;
}

.border-top {
  border-top: 18px solid #e5e5e5 !important;
}

.returnmb {
  margin-bottom: -40px !important;
}

.disabled-link {
  pointer-events: none;
  color: #aaa !important;
}
.image-container {
  position: relative;
  display: inline-block;
}
.lot-image {
  width: 186px;
  height: 184px;
  cursor: pointer;
}
.cancel-icon {
  position: absolute;
  top: 0px;
  right: 0px;
  cursor: pointer;
  background-color: #ffff;
}
.image-rad-size{
  width: 186px;
  height: 184px;
  border-radius: 8px;
}
.custom-control_outlined .v-expansion-panel__shadow {
  box-shadow: none !important;
}

.custom-control_outlined {
  min-height: 56px;
  border-width: 1px;
  border-color: rgba(0,0,0,.42);
  border-style: solid;
  text-align: left;
}
.custom-control_outlined{
  min-height: 56px;
  border-width: 1px;
  border-radius: 4px;
  border-color: rgba(0,0,0,.6);
  border-style: solid;
}
.custom-control_outlined button:focus {
  outline: none;
}
.error-text {
  color: red;
  font-size: 12px;
}
.border-icon-style{
  border: solid 1px !important;
    padding: 20px !important;
}
</style>